<!-- modalOnly (embebido por el Inventario Real y Teórico): la card completa de
     tablas no se pinta — de este componente solo vive el modal de nueva
     solicitud (showOrderForm) que abre el prefill consumido en ngOnInit. -->
<div
  class="card pipes-req-shell"
  *ngIf="!modalOnly"
  [class.pipes-station-only]="onlyStation"
>
  <div class="card-body pipes-card-body">
    <!-- En la solicitud de pipas (dos tablas apiladas + botón) el wrapper crece con el contenido
             (sin height-panel fijo) para que la tarjeta las contenga; cada tabla tiene su scroll interno. -->
    <div class="dataTables_wrapper" [class.height-panel]="!requestFlow">
      <!-- ==================== Solicitud de Pipas — rediseño (requestFlow) ==================== -->
      <!-- "Sugerencias de la semana" (junta MOBICO 2026-07-27: "debe ir dentro de la
                 solicitud de pipa", "ver una lista y dar confirmar o no", "no hay necesidad
                 de un calendario"). Sustituye a la vista /gasprecio/sugerencia-pedidos.
                 "Pedir" / "Pedir todas" abren el modal de nueva solicitud con la(s) pipa(s)
                 precargada(s) para completar PO y material (junta 2026-07-31). Misma tabla
                 en estación y Tablero; la columna Estación solo aparece en Tablero. -->
      <div
        class="pipes-req__section pipes-suggest"
        *ngIf="requestFlow && (!cronoOnly || withSuggest) && (suggestLoading || allSuggestRows.length)"
      >
        <div class="pipes-req__orders-head">
          <h2 class="pipes-req__section-title">
            Sugerencias de la semana
            <!-- Inventario proyectado (revisión 08-oct): UN solo acceso junto al
                 título (por fila "era mucho"); el modal elige estación y producto. -->
            <button type="button" class="sug-proj-btn" aria-label="Inventario proyectado"
              pTooltip="Ver inventario proyectado" tooltipPosition="top" [showDelay]="150" tooltipStyleClass="cap-tooltip"
              (click)="openSuggestProjection()" [disabled]="projOpening">
              <!-- Mientras llegan los días pasados (clic antes de tiempo), el ícono gira en lugar de abrir a medias. -->
              <i class="fa" [ngClass]="projOpening ? 'fa-circle-o-notch fa-spin' : 'fa-line-chart'" aria-hidden="true"></i>
            </button>
            <!-- El conteo "N pipas en M estaciones" se retiró (feedback 09-sep): con el
                 filtro de Grupo son cinco filtros y "Pedir todas", y el conteo era lo que
                 empujaba la banda a un segundo renglón. El dato se lee en la propia tabla,
                 que es la que se está mirando. -->
          </h2>
          <!-- visibility y no *ngIf: con *ngIf cada carga de sugerencias destruía y
               recreaba el app-select-week (un GET /weeks extra por carga, y el
               riesgo de loop de requests que ya documenta la banda del Cronograma). -->
          <div
            class="pipes-suggest__actions"
            [style.visibility]="suggestLoading ? 'hidden' : null"
          >
            <!-- Filtros de la tabla (F-7 + ajuste 2026-07-31, set definitivo del
                 Tablero: semana, producto, zona y estación — el de fecha se
                 retiró). En la vista de ESTACIÓN solo Producto acompaña al
                 selector de semana. Zona = app-select-market, el alcance
                 compartido de la página (sharedZone: al cambiarla refetchean
                 sugerencias, Solicitudes y Cronograma); Estación reusa
                 stationFilterOptions (la lista de Solicitudes) y filtra local,
                 igual que Producto. Orden geografía → estación → producto →
                 semana, como la banda del Cronograma. -->
            <ng-container>
              <div class="pipes-req__field" *ngIf="!onlyStation">
                <app-select-market [allowedZones]="allowedZoneIds"></app-select-market>
              </div>
              <!-- Grupo: solo cuando la cuenta abarca más de uno (acuerdo junta
                   19-ago §5.2). Es alcance de página: la misma selección acota
                   sugerencias, solicitudes, cronograma y el dropdown de Estación. -->
              <div class="pipes-req__field" *ngIf="groupFilterOptions.length">
                <ngx-select
                  class="op-ngx-select"
                  [allowClear]="false"
                  [noAutoComplete]="true"
                  [items]="groupFilterOptions"
                  optionValueField="value"
                  optionTextField="label"
                  placeholder="Todos los grupos"
                  [(ngModel)]="groupFilter"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onGroupFilterChange()"
                >
                </ngx-select>
              </div>
              <!-- Buscador de estación en lugar del dropdown (Edey 19-oct: «quitar los filtros de
                   estación y dejar buscadores»), mismo control que Solicitudes y Cronograma. -->
              <div class="pipes-req__field pipes-crono__search" *ngIf="!onlyStation">
                <i class="fa fa-search" aria-hidden="true"></i>
                <input
                  type="search"
                  placeholder="Buscar estación"
                  aria-label="Buscar estación"
                  [(ngModel)]="suggestSearch"
                  [ngModelOptions]="{ standalone: true }"
                  (input)="onSuggestWeekModeChange()"
                />
              </div>
              <div class="pipes-req__field">
                <ngx-select
                  class="op-ngx-select"
                  [allowClear]="false"
                  [items]="suggestProductFilterOptions"
                  optionValueField="value"
                  optionTextField="label"
                  placeholder="Todos los productos"
                  [(ngModel)]="suggestProductFilter"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onSuggestWeekModeChange()"
                >
                </ngx-select>
              </div>
            </ng-container>
            <!-- Semana: el MISMO app-select-week de Solicitudes y Cronograma
                 (revisión 08-oct "que mueva todas las tablas, no solo una"): una
                 sola semana para las tres tablas vía SharedService; las
                 sugerencias se acotan local al intervalo elegido (ver
                 applySuggestWeekFilter). Antes era un selector propio de dos
                 opciones (siguiente / en curso) que solo movía esta tabla y
                 decía "Semana en curso" donde las otras dicen "Semana actual". -->
            <!-- onlyCurrentAndNext (Edey 16-oct): solo se sugiere para la semana
                 actual y la siguiente, así que la lista no ofrece más. -->
            <div class="pipes-req__field">
              <app-select-week currentWeekLabel="Semana actual" [twoWeeksOption]="true" [multiWeeks]="true" [onlyCurrentAndNext]="true"></app-select-week>
            </div>
            <!-- Sin botón "Ocultar" (pedido 2026-07-31): la sección siempre se
                 muestra completa. -->
            <!-- Se deshabilita cuando ya no queda ninguna pendiente: sin esto
                 el botón seguiría "funcionando" sin abrir nada (las repetidas
                 se filtran en openSuggestionModal) y parecería roto. -->
            <button
              type="button"
              class="row-action-btn green"
              *ngIf="suggestPipesCount && canUseSuggestion"
              [disabled]="!suggestPendingCount"
              [title]="
                suggestPendingCount
                  ? 'Abre la solicitud con todas las pipas sugeridas para completar PO y material'
                  : 'Todas las sugerencias ya están en la solicitud'
              "
              (click)="useAllSuggestions()"
            >
              {{
                suggestPendingCount
                  ? "Pedir todas"
                  : "Todas en la solicitud"
              }}
            </button>
          </div>
        </div>

        <div class="pipes-suggest__loading" *ngIf="suggestLoading">
          Calculando sugerencias…
        </div>

        <!-- MISMA tabla que "Solicitudes" (pedido 2026-07-29: reutilizar el
             componente de tablas de esta vista, no uno propio): ngx-datatable
             con la receta .orders-summary — header gris de 50px, filas de 32px,
             zebra, hover y todo alineado a la izquierda. El SCSS de esa receta
             se extendió a .pipes-suggest en lugar de duplicarse.
             ⚠️ columnMode="force" colapsa columnas a 0px si no llevan minWidth
             (mordió antes a las otras tablas del flujo): TODAS lo declaran. -->
        <!-- Refuerzo del scroll interno (F-8, junta 2026-07-31: "no es claro
             que la tabla tiene scroll"): canal del scrollbar visible (SCSS) y
             degradado sticky "hay más abajo" que se apaga al llegar al fondo.
             Solo se pinta cuando la lista realmente desborda (más filas que
             pipesPageSize, el alto máximo del wrapper). -->
        <div
          class="orders-summary-scroll pipes-suggest__scroll"
          *ngIf="!suggestLoading"
          (scroll)="onSuggestScroll($event)"
        >
          <ngx-datatable
            class="bootstrap selection-cell orders-summary"
            [columnMode]="'force'"
            [headerHeight]="50"
            [rowHeight]="32"
            [rows]="suggestRows"
            [scrollbarV]="false"
            [scrollbarH]="false"
            [rowClass]="getSuggestRowClass"
            [messages]="{ emptyMessage: 'Sin sugerencias para esta semana' }"
          >
            <!-- Solo en Tablero: en la vista de una estación la columna sobra. -->
            <ngx-datatable-column
              *ngIf="!onlyStation"
              prop="stationName"
              name="Estación"
              [width]="stationColWidth"
              [minWidth]="stationColWidth"
              [sortable]="false"
              [cellClass]="'left-side green-gray'"
              [headerClass]="'left-side top-side green-gray'"
            >
              <!-- "Dispensario" (revisión 14-oct): el mismo ícono del Tablero de
                   Inventario. Abre ESA estación en la vista de estación de Solicitud de
                   pipas (Edey 15-oct), igual que el ícono de Solicitudes. -->
              <ng-template let-row="row" ngx-datatable-cell-template>
                <i
                  class="mdi mdi-gas-station stn-go"
                  *ngIf="gasprecioService.canOpenPipesStation(row.stationId)"
                  title="Ir a la estación"
                  (click)="gasprecioService.openPipesStation(row.stationId, '/gasprecio/solicitud-pipas')"
                ></i
                >{{ row.stationName || "—" }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="productLabel"
              name="Producto"
              [width]="120"
              [minWidth]="110"
              [sortable]="false"
              [cellClass]="onlyStation ? 'left-side green-gray' : ''"
              [headerClass]="
                onlyStation ? 'left-side top-side green-gray' : 'top-side'
              "
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span
                  class="pipes-suggest__product"
                  [ngClass]="'mobil-' + row.product"
                  >{{ row.productLabel }}</span
                >
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="inventoryToday"
              name="Inventario actual"
              [width]="140"
              [minWidth]="130"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container *ngIf="row.inventoryToday !== null; else sinInv">
                  {{ row.inventoryToday | number: "1.0-0" }} lts
                </ng-container>
                <ng-template #sinInv
                  ><span class="pipes-suggest__dash">—</span></ng-template
                >
              </ng-template>
            </ngx-datatable-column>
            <!-- Columnas analíticas (F-4, junta 2026-07-31): la tabla explica el
                 PORQUÉ del pedido — cuántos días aguanta el inventario de hoy al
                 ritmo de la venta pronosticada, y esa venta. Debajo del mínimo
                 configurado, los días se marcan en rojo. -->
            <ngx-datatable-column
              prop="daysLeft"
              name="Días de inventario"
              [width]="140"
              [minWidth]="130"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container *ngIf="row.daysLeft !== null; else sinDias">
                  <span
                    class="pipes-suggest__days"
                    [class.is-low]="
                      row.thresholdDays !== null &&
                      row.daysLeft < row.thresholdDays
                    "
                    [title]="
                      row.thresholdDays !== null
                        ? 'Mínimo configurado: ' + row.thresholdDays + ' días'
                        : ''
                    "
                    >{{ row.daysLeft | number: "1.1-1" }} días</span
                  >
                </ng-container>
                <ng-template #sinDias
                  ><span class="pipes-suggest__dash">—</span></ng-template
                >
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="dailySale"
              name="Venta diaria"
              [width]="130"
              [minWidth]="120"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container *ngIf="row.dailySale !== null; else sinVenta">
                  <span
                    [title]="
                      row.hasSuggestion
                        ? 'Promedio de la venta pronosticada de mañana a la fecha sugerida'
                        : 'Promedio de la venta pronosticada hasta el fin del horizonte (semana siguiente)'
                    "
                    >{{ row.dailySale | number: "1.0-0" }} lts/día</span
                  >
                </ng-container>
                <ng-template #sinVenta
                  ><span class="pipes-suggest__dash">—</span></ng-template
                >
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="dateLabel"
              name="Fecha sugerida"
              [width]="150"
              [minWidth]="140"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container *ngIf="row.hasSuggestion; else sinPedido">
                  <span
                    class="pipes-suggest__when"
                    [ngClass]="'u-' + row.urgency"
                    >{{ row.dateLabel }}</span
                  >
                  <i
                    class="fa fa-info-circle pipes-suggest__why"
                    title="¿Por qué esta sugerencia?"
                    (click)="openWhy(row)"
                  ></i>
                </ng-container>
                <!-- "No requiere pedido" se lee POR SEMANA (08-oct): también cuando el
                     producto tiene pipa en otra semana. El hover dice cuándo cae. -->
                <ng-template #sinPedido>
                  <span [title]="row.otherWeek ? 'Esta semana no. La pipa sugerida cae el ' + row.otherWeek : ''">No requiere pedido</span>
                </ng-template>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="liters"
              name="Capacidad sugerida"
              [width]="150"
              [minWidth]="140"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container *ngIf="row.liters !== null; else sinCap">
                  {{ row.liters | number: "1.0-0" }}
                </ng-container>
                <ng-template #sinCap
                  ><span class="pipes-suggest__dash">—</span></ng-template
                >
              </ng-template>
            </ngx-datatable-column>
            <!-- Solo quien puede pedir: el admin ve las sugerencias como lectura
                 (revisión 14-oct), igual que en el Tablero de Inventario. -->
            <ngx-datatable-column
              *ngIf="canUseSuggestion"
              name="Acciones"
              [width]="120"
              [minWidth]="110"
              [sortable]="false"
              [cellClass]="'right-side'"
              [headerClass]="'top-side right-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <ng-container *ngIf="row.hasSuggestion; else sinAccion">
                  <!-- Ya está en una solicitud abierta (el modal de completar
                       pedido): el botón se cambia por el estado (pedido
                       2026-07-29). Quitar el botón —en vez de sólo
                       deshabilitarlo— es lo que impide duplicar la pipa a base
                       de clics repetidos. Vuelve al cancelar el modal o al
                       enviar el pedido (la lista se recalcula). -->
                  <span
                    class="status-label status-confirmed"
                    *ngIf="isSuggestionQueued(row); else pedirBtn"
                    title="Ya está en la solicitud abierta, marcada como sugerencia"
                  >
                    <i class="fa fa-check" aria-hidden="true"></i>
                    En la solicitud
                  </span>
                  <ng-template #pedirBtn>
                    <button
                      type="button"
                      class="row-action-btn green"
                      (click)="useSuggestion(row)"
                    >
                      Pedir
                    </button>
                  </ng-template>
                </ng-container>
                <ng-template #sinAccion
                  ><span class="pipes-suggest__dash">—</span></ng-template
                >
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
          <!-- Degradado sticky "hay más abajo" (F-8): último hijo del wrapper
               con scroll, pegado a su borde inferior; pointer-events none para
               no robar clics a la última fila visible. -->
          <div
            class="pipes-suggest__more"
            *ngIf="suggestRows.length > pipesPageSize && !suggestScrollEnd"
            aria-hidden="true"
          ></div>
        </div>
      </div>

      <!-- "Nueva solicitud" (solo estación): formulario inline MULTI-pipa, sin card contenedora.
                 Reutiliza el mismo modelo/lógica que el modal multi-pipa (addOrderRow,
                 removeOrderRow, updateRowSpace, rowOverSpace, orderFormValid, submitOrderForm). En
                 Tablero (grupo de estaciones) la estación se elige dentro del modal, así que en su
                 lugar se muestra el CTA que lo abre (bloque aparte, sin cambios).
                 Itera inlineForms (no orderForms): mientras el modal de "Pedir" está
                 abierto, orderForms son las pipas del modal y este formulario debe seguir
                 mostrando el borrador del usuario SIN autocompletarse con la sugerencia
                 (feedback 2026-07-31 — solo se llena el modal). -->
      <div
        class="pipes-req__section pipes-req__section--new"
        *ngIf="reqst === 1 && requestFlow && onlyStation && !cronoOnly"
      >
        <h2 class="pipes-req__section-title">Nueva solicitud</h2>

        <!-- Header de labels compartido: mismas columnas que cada fila de pipa de abajo (sin caja). -->
        <div class="pipes-req__cols-head">
          <span>PO#</span>
          <span>Fecha requerida</span>
          <span>Capacidad</span>
          <span>Producto</span>
          <span aria-hidden="true"></span>
        </div>

        <!-- Alto acotado + scroll interno (pedido 2026-07-29: "cuando son muchas
             pipas la vista se extiende demasiado"), mismo mecanismo que ya usa
             este bloque dentro del modal del Inventario: labels de columnas y
             "Enviar pedido" quedan fijos, las pipas y "Agregar pipa" scrollean. -->
        <div class="pipes-req__rows-scroll">
          <div
            class="pipes-req__pipa"
            *ngFor="let f of inlineForms; let i = index"
          >
            <!-- De dónde salió esta solicitud (pedido 2026-07-29: "que se indique
                 cuál es la solicitud"). Ocupa el ancho completo del grid, así que
                 no descuadra las columnas ni en la variante con Estación. Es el
                 otro extremo del chip "En la solicitud" de la lista de arriba:
                 ahí se ve que la sugerencia ya bajó, acá cuál de todas es. -->
            <div class="pipes-req__pipa__origin" *ngIf="f.suggestLabel">
              <i class="fa fa-truck" aria-hidden="true"></i>
              Sugerencia de la semana · {{ f.suggestLabel }}
            </div>
            <div class="pipes-req__pipa__field">
              <span class="pipes-req__pipa__mlabel">PO#</span>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="f.po"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!editingOrderId"
                [placeholder]="editingOrderId ? 'Ej. PET8EX01' : 'Elige el tipo'"
              />
            </div>
            <div class="pipes-req__pipa__field">
              <span class="pipes-req__pipa__mlabel">Fecha requerida</span>
              <input
                type="date"
                class="form-control"
                [class.is-placeholder]="!f.loadDate"
                [class.is-invalid]="rowDateTooEarly(f)"
                [min]="minRequestDate"
                [title]="rowDateTooEarly(f) ? minRequestDateTitle : ''"
                [(ngModel)]="f.loadDate"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="updateRowSpace(f)"
              />
            </div>
            <div class="pipes-req__pipa__field">
              <span class="pipes-req__pipa__mlabel">Capacidad</span>
              <!-- Campo libre con separador de miles para admin Y solicitante (Edey 20-oct;
                   antes el solicitante elegía de 5,000 en 5,000). Si la estación tiene
                   capacidades permitidas cargadas, el API rechaza las demás con su mensaje. -->
              <input
                type="text"
                inputmode="numeric"
                class="form-control"
                (keypress)="numberOnly($event)"
                [class.over-space]="rowOverSpace(f)"
                [ngModel]="formatThousands(f.capacity)"
                (ngModelChange)="f.capacity = parseThousands($event)"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Ej. 30,000"
              />
              <!-- Candado de inventario: mismo mecanismo/copys que el modal multi-pipa. -->
              <small class="space-hint muted" *ngIf="f.spaceLoading">
                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                Consultando espacio…
              </small>
              <!-- El pill rojo ES el botón del desglose (2026-07-13 v2 "sin ampliar
                   más"): click abre el modal "¿Por qué no hay espacio?". -->
              <small
                class="space-hint"
                [class.over]="rowOverSpace(f)"
                *ngIf="!f.spaceLoading && f.availableSpace != null"
                (click)="rowOverSpace(f) && openSpaceInfo(f)"
                [title]="
                  rowOverSpace(f)
                    ? 'Ver por qué no hay espacio'
                    : f.spaceBasis === 'theoretical'
                      ? 'Espacio a la fecha de entrega: capacidad del tanque menos inventario TEÓRICO del día (el mismo del Cronograma) y arrastre'
                      : 'Espacio a la fecha de entrega: capacidad del tanque menos la lectura real del volumétrico y arrastre'
                "
              >
                <i
                  class="fa"
                  [ngClass]="
                    rowOverSpace(f) ? 'fa-exclamation-triangle' : 'fa-tint'
                  "
                  aria-hidden="true"
                ></i>
                <span>
                  <ng-container *ngIf="!rowOverSpace(f)"
                    >Espacio disp.
                    {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                  >
                  <ng-container *ngIf="rowOverSpace(f) && rowEffectiveSpace(f)"
                    >Excede máx.
                    {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                  >
                  <ng-container *ngIf="rowOverSpace(f) && !rowEffectiveSpace(f)"
                    >Sin espacio disponible</ng-container
                  >
                  <i
                    class="fa fa-question-circle space-hint__q"
                    *ngIf="rowOverSpace(f)"
                    aria-hidden="true"
                  ></i>
                </span>
              </small>
              <small
                class="space-hint muted"
                *ngIf="
                  !f.spaceLoading && f.spaceChecked && f.availableSpace == null
                "
                title="La estación no tiene capacidad de tanque o lectura de inventario para este producto"
              >
                <i class="fa fa-info-circle" aria-hidden="true"></i> Sin datos de
                inventario
              </small>
            </div>
            <div class="pipes-req__pipa__field">
              <span class="pipes-req__pipa__mlabel">Producto</span>
              <!-- ngx-select (mismo componente del campo Estación) en lugar del
                   select nativo: las opciones nativas no pueden llevar el tag de
                   color por producto (pedido 2026-07-31). El chip es el mismo
                   mobil-* de la lista de sugerencias. Sin buscador (3 opciones). -->
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [noAutoComplete]="true"
                [items]="orderProductOptions"
                optionValueField="value"
                optionTextField="label"
                placeholder="Selecciona…"
                appendTo="body"
                [dropDownMenuOtherClasses]="'op-appended-dropdown'"
                [(ngModel)]="f.product"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="updateRowSpace(f)"
              >
                <ng-template ngx-select-option let-option>
                  <span
                    class="pipes-suggest__product"
                    [ngClass]="'mobil-' + option.value"
                    >{{ option.text }}</span
                  >
                </ng-template>
                <ng-template ngx-select-option-selected let-option>
                  <span
                    class="pipes-suggest__product"
                    [ngClass]="'mobil-' + option.value"
                    >{{ option.text }}</span
                  >
                </ng-template>
              </ngx-select>
            </div>
            <!-- Material ya no se captura (junta MOBICO 16-oct): es un concepto interno de
                 MOBICO (ROC / metropolitana); la estación solo elige el Tipo. -->
            <div class="pipes-req__pipa__remove">
              <!-- Patrón estándar de eliminar del portal (.icon.delete, mismo del cronograma).
                               Siempre visible: deshabilitado mientras solo haya una pipa. -->
              <i
                class="fa fa-trash-o icon delete"
                aria-hidden="true"
                [class.disabled]="inlineForms.length < 2"
                (click)="inlineForms.length > 1 && removeOrderRow(i)"
                [title]="
                  inlineForms.length > 1
                    ? 'Eliminar pipa'
                    : 'La solicitud necesita al menos una pipa'
                "
              ></i>
            </div>
          </div>

          <button
            type="button"
            class="pipes-req__add-pipa"
            (click)="addOrderRow()"
          >
            <i class="fa fa-plus" aria-hidden="true"></i> Agregar pipa
          </button>
        </div>
        <!-- /pipes-req__rows-scroll -->

        <div class="pipes-req__new-foot">
          <button
            type="button"
            class="pipes-req__submit"
            [disabled]="!orderFormValid || savingOrder"
            (click)="submitOrderForm()"
          >
            {{ savingOrder ? "Enviando…" : "Enviar pedido" }}
          </button>
        </div>
      </div>

      <!-- Tablero (grupo de estaciones): mismo formulario inline multi-pipa que la guía
                 (onlyStation), con una columna extra "Estación" (entre Fecha requerida y
                 Capacidad, mismo orden MOBICO que el modal) porque acá la estación no es
                 implícita. Reutiliza el mismo modelo/lógica (orderForms, addOrderRow,
                 removeOrderRow, updateRowSpace, rowOverSpace, orderFormValid,
                 submitOrderForm); el ngx-select de Estación es el mismo componente buscable
                 que usa el modal (f.station, updateRowSpace en el change). -->
      <!-- El formulario "Nueva solicitud" (formato tablero, con Estación) vive en el
           ng-template #newOrderStationForm (raíz del template) para renderizarse en DOS
           lugares con los MISMOS estilos: inline aquí y dentro del modal del inventario
           (modalOnly) — feedback 2026-07-16 "el modal no sigue los estilos de solicitudes". -->
      <!-- !cronoOnly: en el Cronograma embebido bajo el panel admin (2026-08-03) no
           debe aparecer el alta de pedidos — esa combinación (tablero + cronoOnly)
           no existía antes de ese embed. -->
      <ng-container *ngIf="reqst === 1 && requestFlow && !onlyStation && !cronoOnly" [ngTemplateOutlet]="newOrderStationForm"></ng-container>

      <!-- Sección "Solicitudes": patrón section-header (kicker + hairline + filtros SIN label,
                 solo placeholder/opción descriptiva — task 2026-07-10 "eliminar los títulos")
                 seguido de la tabla única "Solicitudes" (formato MOBICO): UNA fila por pedido,
                 sin desglose de historial. El Tipo y el estatus reflejan la solicitud en curso: el
                 cambio en vuelo si lo hay (con su valor nuevo), si no el pedido tal cual. -->
      <div
        class="pipes-req__orders pipes-req__section"
        *ngIf="requestFlow && !cronoOnly"
      >
        <!-- Título + filtros en la MISMA banda (una sola línea del header, sin
                     banda vertical extra para los filtros): título a la izquierda
                     y los filtros pegados a él (revisión 06-oct). La hairline de cierre del header la aporta
                     .pipes-req__orders-head (no el título, ver SCSS). -->
        <div class="pipes-req__orders-head">
          <h2 class="pipes-req__section-title">
            Solicitudes
            <!-- Excel de lo visible (pedido MOBICO 08-oct): junto al título, como el
                 botón de gráfica de Sugerencias, para no partir la fila de filtros. -->
            <button type="button" class="sug-proj-btn" aria-label="Descargar Excel"
              pTooltip="Descargar Formato de Cambios (MOBICO) con las solicitudes visibles" tooltipPosition="top" [showDelay]="150" tooltipStyleClass="cap-tooltip"
              [disabled]="!requestRows.length" (click)="exportRequestsExcel()">
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </button>
          </h2>
          <div class="pipes-req__orders-filters">
            <!-- Buscador primero (revisión 06-oct): estación o PO, mismo control
                 que el del Cronograma (.pipes-crono__search). -->
            <div class="pipes-req__field pipes-crono__search">
              <i class="fa fa-search" aria-hidden="true"></i>
              <input
                type="search"
                placeholder="Buscar estación o PO"
                aria-label="Buscar estación o PO"
                [(ngModel)]="ordersSearch"
                [ngModelOptions]="{ standalone: true }"
                (input)="applyFilters()"
              />
            </div>
            <!-- Grupo/Zona/Estación (Tablero: elegir de qué grupo/comercializadora se ven las
                         solicitudes). SOLO !onlyStation: en la guía (onlyStation) la estación ya es
                         implícita y estos tres filtros no aplican, por eso el guard extra en cada uno
                         (el header "Solicitudes" completo se comparte con la guía vía *ngIf="requestFlow"). -->
            <div class="pipes-req__field" *ngIf="!onlyStation && rol === 'Dios'">
              <app-select-group></app-select-group>
            </div>
            <!-- Zona se ELIMINÓ de esta banda (task 2026-07-09, mismo criterio que
                 en el header del tablero de cronograma): con el filtro de Estación
                 y la columna Estación en la tabla, la zona solo estorbaba. -->
            <div class="pipes-req__field" *ngIf="!onlyStation && groupFilterOptions.length">
              <!-- Mismo groupFilter que la banda de sugerencias: una sola
                   selección de grupo gobierna toda la página. -->
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [noAutoComplete]="true"
                [items]="groupFilterOptions"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los grupos"
                [(ngModel)]="groupFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onGroupFilterChange()"
              >
              </ngx-select>
            </div>
            <!-- El dropdown de estación se quitó (Edey 19-oct): el buscador de arriba filtra por estación o PO. -->
            <div class="pipes-req__field">
              <!-- currentWeekLabel: sin título arriba, la opción de la semana
                   actual se muestra como "Semana actual" para que el control se
                   autoexplique (las demás semanas conservan su rango de fechas). -->
              <!-- periodOptions: la misma lista termina con "Mes actual" / "Mes anterior"
                   (revisión 08-oct, un solo filtro). Mueve Solicitudes y Cronograma;
                   Sugerencias se queda en su semana. -->
              <app-select-week currentWeekLabel="Semana actual" [periodOptions]="true" [twoWeeksOption]="true" [multiWeeks]="true"></app-select-week>
            </div>
            <div class="pipes-req__field">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="orderFilterProducts"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los productos"
                [(ngModel)]="productFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
            <div class="pipes-req__field">
              <!-- Fecha requerida (junta 27-oct): ubicar las pipas de un día. -->
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [noAutoComplete]="true"
                [items]="requiredDateFilterOptions"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todas las fechas"
                [(ngModel)]="requiredDateFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
            <div class="pipes-req__field">
              <!-- Tipo de solicitud (junta 19-oct): filtra por lo que la fila muestra. -->
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [noAutoComplete]="true"
                [items]="orderFilterTypes"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los tipos"
                [(ngModel)]="typeFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
            <div class="pipes-req__field">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="orderFilterStatuses"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los estatus"
                [(ngModel)]="statusFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
          </div>
        </div>

        <!-- Scroll por wrapper CSS (no el virtual de ngx-datatable): con columnMode force + scroll
                 vertical y muchas filas (Tablero) el header/cuerpo se desalinean. Con scrollbarV=false
                 la tabla renderiza todas las filas y el wrapper (header sticky) hace el scroll. -->
        <!-- Sin paginación (pedido 2026-07-13): todas las solicitudes bajo el
             scroll interno, pintadas por lotes (ver onOrdersScroll). -->
        <div class="orders-summary-scroll" *ngIf="reqst === 1" (scroll)="onOrdersScroll($event)">
          <!-- trackByProp: SIN él ngx-datatable trackea por índice posicional y al
                     insertar/quitar filas de historial las clases se recorren entre
                     elementos DOM reusados → re-animaba filas que no cambiaron.
                     (rowIdentity NO alimenta el trackBy; es bookkeeping interno.) -->
          <ngx-datatable
            class="bootstrap selection-cell orders-summary"
            [columnMode]="'force'"
            [headerHeight]="50"
            [rowHeight]="32"
            [rows]="requestRows"
            [scrollbarV]="false"
            [scrollbarH]="false"
            [rowClass]="getRowClass"
            [rowIdentity]="rowIdentity"
            [trackByProp]="'_id'"
            [messages]="{ emptyMessage: emptyRequestsMessage }"
          >
            <!-- Columna Tipo: los nombres del Formato de cambios van en UNA sola línea (usuario, 16-oct;
                     antes el chip envolvía a 2 líneas y la columna era más angosta, coordinación 2026-07-09).
                     Con columnMode force el minWidth es un piso duro: 170px = slot del caret 15px + chip
                     "Cambio de capacidad" (~140px a 10.5px) + inset de celda. -->
            <ngx-datatable-column
              prop="type_label"
              name="Tipo"
              [width]="170"
              [minWidth]="170"
              [maxWidth]="190"
              [sortable]="false"
              [cellClass]="'left-side green-gray'"
              [headerClass]="'left-side top-side green-gray'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <!-- Slot fijo del caret: reserva el mismo ancho en todas las filas para
                             que el chip quede alineado. El caret solo aparece en el pedido padre
                             con historial; al expandir, sus filas se insertan debajo. -->
                <!-- Chevron rotatorio (mecánica de acordeón): un solo ícono que gira
                             90° al abrir, en lugar de intercambiar right/down sin transición. -->
                <span class="oh-toggle-slot">
                  <i
                    class="fa fa-chevron-right oh-toggle"
                    [class.open]="isHistoryOpen(row)"
                    *ngIf="!row.is_history && row.has_history"
                    title="Ver historial de la solicitud"
                    aria-hidden="true"
                    (click)="toggleHistory(row)"
                  ></i>
                </span>
                <span class="type-chip" [ngClass]="row.change_kind">{{
                  row.type_label
                }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="po_number"
              name="PO"
              [width]="100"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <!-- Fila del historial: el PO tal como estaba ANTES de ese cambio; si el pedido pasó a otro PO, el
                     tooltip lo dice (el anterior ya no se reutiliza). La fila del pedido lleva el vigente. -->
                <span [title]="row.is_history ? historyPoTitle(row) : ''">{{
                  row.po_number || "—"
                }}</span>
              </ng-template>
            </ngx-datatable-column>
            <!-- Orden de las primeras columnas (revisión 07-oct): Tipo · PO · Producto ·
                 Fecha de solicitud, el MISMO en Solicitudes (admin y solicitante) y en
                 el Cronograma. -->
            <!-- Producto angosto (task 2026-07-09 "ocupa mucho espacio"): el material
                 largo ya se trunca con tooltip (.material-cell). -->
            <ngx-datatable-column
              prop="material"
              name="Producto"
              [width]="150"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <!-- Chip de color por producto (F-9, junta 2026-07-31: "ponle el
                   formato de extra/diésel del color para identificar rápido qué
                   producto es en las solicitudes") — el mismo mobil-* de la
                   lista de sugerencias, delante del material (que conserva su
                   truncado con tooltip). -->
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="material-with-product">
                  <span
                    class="pipes-suggest__product"
                    *ngIf="row.product"
                    [ngClass]="'mobil-' + row.product"
                    >{{ productLabel(row.product) }}</span
                  >
                  <!-- Material = concepto interno de MOBICO (junta 16-oct): la estación solo ve el Tipo. -->
                  <span class="material-cell" *ngIf="isMobicoAdmin" [title]="row.material || ''">{{
                    row.material || "—"
                  }}</span>
                </span>
              </ng-template>
            </ngx-datatable-column>
            <!-- Fecha de solicitud = cuándo se creó (timestamp real → hora de México).
                     Encabezado en UNA línea (task 2026-07-09 "ocupan dos renglones"): ancho
                     suficiente para el label completo + nowrap del header (ver SCSS). -->
            <ngx-datatable-column
              prop="request_date"
              name="Fecha de solicitud"
              [width]="125"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{
                  row.request_date
                    ? (row.request_date | date: "dd/MM/yy" : "-0600" : "es")
                    : "—"
                }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="order_delivery_date"
              name="Fecha requerida"
              [width]="115"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{
                  row.order_delivery_date
                    ? (row.order_delivery_date
                      | date: "dd/MM/yy" : "+0000" : "es")
                    : "—"
                }}
              </ng-template>
            </ngx-datatable-column>
            <!-- Solo en Tablero (varias estaciones): en la vista de una sola estación
                     (onlyStation) la columna sobra, la estación ya es la seleccionada. -->
            <ngx-datatable-column
              *ngIf="!onlyStation"
              prop="station_name"
              name="Estación"
              [width]="stationColWidth"
              [minWidth]="stationColWidth"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <!-- "Dispensario" (revisión 14-oct): abre ESA estación en la vista de
                   estación de Solicitud de pipas (Edey 15-oct), igual que en Sugerencias. -->
              <ng-template let-row="row" ngx-datatable-cell-template>
                <i
                  class="mdi mdi-gas-station stn-go"
                  *ngIf="gasprecioService.canOpenPipesStation(row.station_id)"
                  title="Ir a la estación"
                  (click)="gasprecioService.openPipesStation(row.station_id, '/gasprecio/solicitud-pipas')"
                ></i
                >{{ row.station_name || "—" }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="truck_capacity"
              name="Capacidad"
              [width]="100"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <!-- Litros aceptados por MOBICO si ya los definió (igual que el admin); si no, la capacidad solicitada.
                     El ícono avisa que lo aceptado difiere de lo pedido y el tooltip da el detalle. -->
                <span
                  class="cap-cell"
                  [pTooltip]="capacityTitle(row)"
                  tooltipPosition="top"
                  [showDelay]="150"
                  tooltipStyleClass="cap-tooltip"
                >
                  {{
                    capacityValue(row)
                      ? (capacityValue(row) | number: "1.0-0")
                      : "—"
                  }}
                  <i
                    *ngIf="showCapacityDiff(row)"
                    class="fa fa-info-circle cap-info"
                    aria-hidden="true"
                  ></i>
                </span>
              </ng-template>
            </ngx-datatable-column>
            <!-- Valor nuevo solicitado (solo cuando hay un cambio en curso; '—' si no) -->
            <ngx-datatable-column
              prop="new_value"
              name="Nuevo valor"
              [width]="110"
              [maxWidth]="140"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <!-- Historial: lo nuevo que se pidió/aceptó; el tooltip del ícono lleva el motivo. -->
                <span class="new-value" [title]="row.is_history ? row.history_reason || '' : ''"
                  >{{ row.new_value
                  }}<i
                    class="fa fa-comment-o history-reason"
                    *ngIf="row.is_history && row.history_reason"
                    role="img"
                    aria-label="Con motivo"
                  ></i
                ></span>
              </ng-template>
            </ngx-datatable-column>
            <!-- Respuesta MOBICO = estatus de lo que la fila muestra; el cambio en curso
                     va en color de revisión (naranja) para distinguirlo del pedido normal -->
            <ngx-datatable-column
              prop="status_label"
              name="Respuesta MOBICO"
              [width]="170"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span
                  class="status-label"
                  [ngClass]="{
                    'status-confirmed': (row.event_status || row.status) === 'confirmed',
                    'status-rejected': (row.event_status || row.status) === 'rejected',
                    'status-review':
                      (row.event_status || row.status) === 'review' || row.in_flight_change,
                  }"
                >
                  {{ row.status_label || "—" }}
                </span>
                <!-- Enviada con poco aviso (regla MOBICO 48/24 hrs): reloj ámbar = menos de 48 hrs (en espera de
                     disponibilidad); triángulo rojo = menos de 24 hrs (puede que no se atienda). Igual que el admin. -->
                <i
                  class="fa deadline-flag"
                  *ngIf="row.deadline_state && row.in_flight_change"
                  [ngClass]="row.deadline_state === 'late' ? 'fa-exclamation-triangle late' : 'fa-clock-o'"
                  [title]="deadlineTitle(row)"
                  aria-hidden="true"
                ></i>
                <!-- Aprobada con ajustes de MOBICO (aceptó otro producto / fecha / litros que los solicitados): el tooltip
                     trae cada valor anterior y el motivo; el detalle completo está en el historial del pedido. -->
                <i
                  class="fa fa-sliders adjust-flag"
                  *ngIf="row.adjustments?.length && !row.in_flight_change && !row.is_history"
                  [title]="'MOBICO aprobó con ajustes\n\n' + adjustmentsTitle(row)"
                  role="img"
                  aria-label="MOBICO aprobó con ajustes"
                ></i>
              </ng-template>
            </ngx-datatable-column>
            <!-- Acciones del pedido: realizar cambio / cancelar (vía aprobación de MOBICO).
                     Botones etiquetados (feedback: los íconos pasaban desapercibidos) con la
                     pareja de botones del portal: "Cambiar" verde CTA y "Cancelar" gris, como
                     los confirm-btn de los modales de este flujo. minWidth evita que
                     columnMode force comprima la columna y corte los botones.
                     SIEMPRE visibles (task 2026-07-10, antes la celda mostraba '—'):
                     deshabilitados cuando el pedido ya no admite acciones (canCancelOrder) —
                     mismo patrón enable/disable que el trash de eliminar pipa del formulario;
                     el tooltip explica el motivo (orderActionsDisabledReason). Solo las filas
                     de historial siguen sin botones. -->
            <ngx-datatable-column
              name="Acciones"
              [width]="160"
              [minWidth]="150"
              [maxWidth]="185"
              [sortable]="false"
              [cellClass]="'right-side'"
              [headerClass]="'top-side right-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <!-- Orden gris → verde (task 2026-07-13 "orden de acciones"):
                     el par replica a los modales del flujo, secundaria primero
                     y la acción principal (verde) al final. -->
                <ng-container *ngIf="!row.is_history; else noOrderActions">
                  <button
                    type="button"
                    class="row-action-btn gray"
                    [disabled]="!canRequestCancel(row)"
                    [title]="
                      cancelDisabledReason(row) ||
                      'Solicitar la cancelación del pedido'
                    "
                    (click)="warningDeleteOrder(row)"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    class="row-action-btn green"
                    [disabled]="!canRequestCancel(row)"
                    [title]="
                      cancelDisabledReason(row) ||
                      'Solicitar un cambio del pedido'
                    "
                    (click)="openChangeForm(row)"
                  >
                    Cambiar
                  </button>
                </ng-container>
                <ng-template #noOrderActions
                  ><span class="mobico-response">—</span></ng-template
                >
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>

      </div>

      <!-- Envoltura de la card "Cronograma": comparte la MISMA tabla que la vista !requestFlow
                 (view=pipes), así que no se puede duplicar. Siempre se ve como card
                 (.pipes-req__section, aplicada sin condición: las vistas que llegan a este div
                 comparten el look moderno).
                 SIN gate desde la junta MOBICO 2026-07-27 ("una sola sección: sugerencias,
                 pedidos y cronogramas"): el Cronograma vuelve a pintarse debajo de la tabla
                 "Solicitudes" en las DOS vistas del flujo (estación y Tablero), de donde se
                 había separado en 2026-07-10. Su columna Estación ya se autogestiona con
                 onlyStation, así que la misma tabla sirve para ambas. -->
      <div class="pipes-crono pipes-req__section">
        <!-- Banda título + filtros del Cronograma de la GUÍA (requestFlow && onlyStation,
                 task 2026-07-10 "traer los filtros a esta tabla" — restaura la banda que se
                 perdió en el merge del rediseño): Semana (control compartido con Solicitudes
                 vía SharedService, sincronizadas a propósito — la semana gobierna el fetch de
                 ambas tablas) y Producto con filtro PROPIO (cronoProductFilter: cada card
                 filtra lo suyo; sin Estatus porque este cronograma solo lista confirmadas).
                 ⚠️ SIN gate por reqst (mismo motivo que las demás bandas, ver comentario
                 de abajo): recrear el app-select-week dispara el loop de requests. -->
        <div class="pipes-req__orders-head" *ngIf="requestFlow">
          <h2 class="pipes-req__section-title">
            Cronograma
            <button type="button" class="sug-proj-btn" aria-label="Descargar Excel"
              pTooltip="Descargar Excel del cronograma visible" tooltipPosition="top" [showDelay]="150" tooltipStyleClass="cap-tooltip"
              [disabled]="!cronogramaFiltered.length" (click)="exportCronogramaExcel()">
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </button>
          </h2>
          <div class="pipes-req__orders-filters">
            <!-- Buscador primero (revisión 06-oct): estación o PO. -->
            <div class="pipes-req__field pipes-crono__search" *ngIf="source === 'orders'">
              <i class="fa fa-search" aria-hidden="true"></i>
              <!-- (input) y no (keyup): la "x" nativa del type=search limpia sin
                   disparar keyup (mismo criterio que el buscador de schedule). -->
              <input
                type="search"
                placeholder="Buscar estación o PO"
                aria-label="Buscar estación o PO"
                [(ngModel)]="cronoSearch"
                [ngModelOptions]="{ standalone: true }"
                (input)="applyFilters()"
              />
            </div>
            <div class="pipes-req__field">
              <!-- periodOptions: la misma lista termina con "Mes actual" / "Mes anterior"
                   (revisión 08-oct, un solo filtro). Mueve Solicitudes y Cronograma;
                   Sugerencias se queda en su semana. -->
              <app-select-week currentWeekLabel="Semana actual" [periodOptions]="true" [twoWeeksOption]="true" [multiWeeks]="true"></app-select-week>
            </div>
            <!-- Grupo (Edey 19-oct: «en Cronograma en admin falta el filtro por grupo»): el MISMO
                 groupFilter de Sugerencias y Solicitudes; el Cronograma ya filtraba por él, solo
                 faltaba el control en su banda. -->
            <div class="pipes-req__field" *ngIf="!onlyStation && groupFilterOptions.length">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [noAutoComplete]="true"
                [items]="groupFilterOptions"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los grupos"
                [(ngModel)]="groupFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onGroupFilterChange()"
              >
              </ngx-select>
            </div>
            <div class="pipes-req__field">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="orderFilterProducts"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los productos"
                [(ngModel)]="cronoProductFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
            <!-- Fecha requerida (Edey 27-oct, como en Solicitudes). -->
            <div class="pipes-req__field" *ngIf="source === 'orders'">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [noAutoComplete]="true"
                [items]="cronoRequiredDateOptions"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todas las fechas"
                [(ngModel)]="cronoRequiredDateFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
            <!-- Estatus del viaje + buscador (revisión 06-oct): solo en el flujo de
                 pedidos, que es el que trae estatus y PO. Las opciones de estatus
                 salen de las filas cargadas (refreshCronoTripStatusOptions). -->
            <div class="pipes-req__field" *ngIf="source === 'orders'">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="cronoTripStatusOptions"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los estatus"
                [(ngModel)]="cronoTripStatusFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
          </div>
        </div>
        <!-- Header moderno del Cronograma del Tablero (view=pipes, !requestFlow), patrón
                 .pipes-req__orders-head de "Solicitudes" (ver arriba). app-last-update se
                 reubica acá (antes vivía en el header legacy que se eliminó). -->
        <!-- El header (con los selects Grupo/Zona/Semana) NO se gatea por reqst: si se
                 destruyera/recreara en cada getData (reqst 0→1), al recrearse los selects
                 re-emitirían al servicio compartido (sharedZone/sharedWeek/sharedGroup) y
                 dispararían otro getData → loop infinito. Mismo criterio que "Solicitudes":
                 el header persiste y SOLO la tabla de abajo se gatea por reqst. -->
        <div class="pipes-req__orders-head" *ngIf="!requestFlow">
          <h2 class="pipes-req__section-title">Cronograma</h2>
          <!-- Filtros SIN label, solo placeholder/opción descriptiva (task
                       2026-07-10 "eliminar los títulos" — mismo criterio que la banda
                       de Solicitudes del flujo). -->
          <div class="pipes-req__orders-filters">
            <div class="pipes-req__field" *ngIf="rol === 'Dios'">
              <app-select-group></app-select-group>
            </div>
            <!-- Filtro por estado (entidad federativa; back filtra por Station.entidad_id).
                 Solo admin MOBICO o grupo solicitante MOBICO: los demás grupos no tienen
                 entidad_id poblado. A diferencia de estación/producto (client-side), este
                 refetchea (getData). Va ANTES de la zona (pedido 2026-07-15): geografía
                 de lo general (estado) a lo particular (zona), aunque el ligado siga
                 siendo zona → acota estados. -->
            <div class="pipes-req__field" *ngIf="(isMobicoAdmin || isMobicoRequester) && showStates">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="stateFilterOptions"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los estados"
                [(ngModel)]="stateFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onStateFilterChange()"
              >
              </ngx-select>
            </div>
            <!-- allowedZoneIds: con estado filtrado, solo zonas compatibles (ligado
                 inverso estado → zonas; null = todas, comportamiento normal). -->
            <div class="pipes-req__field">
              <app-select-market [allowedZones]="allowedZoneIds"></app-select-market>
            </div>
            <div class="pipes-req__field">
              <!-- Mismo dropdown buscable de estaciones que "Solicitudes" (sin "X" de
                           limpiar: stationFilterOptions ya trae "Todas las estaciones" como
                           primera opción para volver a "sin filtro"). -->
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="stationFilterOptions"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todas las estaciones"
                [(ngModel)]="stationFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
                <ng-template ngx-select-option-not-found let-input
                  >"{{ input }}" no encontrada</ng-template
                >
              </ngx-select>
            </div>
            <div class="pipes-req__field">
              <app-select-week currentWeekLabel="Semana actual" [twoWeeksOption]="true" [multiWeeks]="true"></app-select-week>
            </div>
            <div class="pipes-req__field">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="orderFilterProducts"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los productos"
                [(ngModel)]="productFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
            <!-- Sin filtro de Estatus (task 2026-07-10): sus opciones eran estatus de
                 fuel-orders (strings) pero las COMPRAS de esta tabla traen un ObjectId
                 del catálogo purchase_status — seleccionar cualquiera vaciaba la tabla.
                 Ya se había quitado el 2026-07-09; el rediseño lo re-agregó por error. -->
          </div>
        </div>
        <!-- Sin scroll virtual (scrollbarV=false) ni altura fija: la tabla se dimensiona
                 al contenido de la página actual (máx. cronoPageSize filas: 5 en el flujo,
                 15 en el Tablero donde la tabla es el único contenido), igual que la
                 tabla "Solicitudes". Así NO queda espacio muerto entre la última fila y el
                 paginador (el scroll virtual con altura fija reservaba header + 5 filas + track
                 del scrollbar aunque la página trajera menos). El look moderno (.orders-cronograma)
                 y la paginación aplican en las 3 vistas por igual. -->
        <!-- Sin paginación (pedido 2026-07-13): todas las entregas bajo el scroll
             interno del wrapper (max-height = header + cronoPageSize filas, según
             la vista), pintadas por lotes (ver onCronoScroll). -->
        <div
          class="crono-scroll"
          [style.max-height.px]="50 + cronoPageSize * 32"
          (scroll)="onCronoScroll($event)"
        >
        <ngx-datatable
          *ngIf="reqst === 1"
          class="bootstrap selection-cell orders-cronograma"
          [class.crono-empty-lg]="cronoPageSize === cronoBoardPageSize"
          [style.--crono-empty-height]="cronoEmptyHeight"
          [columnMode]="'force'"
          [headerHeight]="50"
          [rowHeight]="getRowHeight"
          [rows]="temp"
          [rowClass]="getRowClass"
          [scrollbarV]="false"
          [scrollbarH]="true"
          [selected]="selected"
          [selectionType]="SelectionType.multiClick"
          [messages]="{ emptyMessage: emptyCronogramaMessage }"
        >
          <!-- Tipo (revisión 07-oct "Adición debe venir arriba y abajo"): el mismo chip
               de Solicitudes. En el Cronograma la fila es el pedido: muestra su cambio
               en vuelo (pending_change_type del back) o "Adición". Solo en el flujo de
               pedidos. Primeras columnas en el MISMO orden que Solicitudes: Tipo · PO ·
               Producto · Fecha de Solicitud (Estación se mantiene junto a PO en el
               Tablero, como el Excel de entregas). Suma 96px al presupuesto de anchos. -->
          <ngx-datatable-column
            *ngIf="source === 'orders'"
            prop="type_label"
            [width]="96"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Tipo</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span class="type-chip" [ngClass]="row.change_kind">{{
                row.type_label
              }}</span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Estación: SOLO en Tablero (task 2026-07-09 "en Inventario sí se debe
               ver de quién es cada pipa"); en la vista de estación es implícita. -->
          <!-- ⚠️ Presupuesto de anchos (columnMode force + scrollbarH): los [width]
               actúan como MÍNIMOS — si su suma rebasa el contenedor, ngx-datatable
               NO comprime, hace scroll horizontal (allowBleed). La columna Estado
               (72) se absorbió rebajando las demás para mantener la suma ≈916px
               (el presupuesto previo, sin scroll en pantallas de escritorio). -->
          <ngx-datatable-column
            *ngIf="!onlyStation"
            prop="station_name"
            [width]="stationColWidth"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Estación</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.station_name || "—" }}
            </ng-template>
          </ngx-datatable-column>

          <!-- PO (revisión 06-oct): justo después de Estación, mismo orden que el
               Excel de entregas (Station Name → Cust PO No.); es el número con el
               que se busca la pipa en ese archivo. frozenLeft para mantener
               contiguo el bloque congelado.
               Solo en el flujo de pedidos; las compras del Tablero legacy no lo
               traen. Suma 76px al presupuesto de anchos: en este flujo no se
               pintan Zona (66) ni Estado (72). -->
          <ngx-datatable-column
            *ngIf="source === 'orders'"
            prop="po_number"
            [width]="76"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>PO</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span [title]="row.po_number || ''">{{ row.po_number || "—" }}</span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Zona: SOLO en el cronograma del Tablero (fix 2026-07-10, acompaña al
               filtro de Zona del header); en la vista de estación la zona es
               implícita. frozenLeft para mantener contiguo el bloque congelado
               (Estación/Zona/Producto/Material). El row.zone ya llega capitalizado
               desde el mapeo de getData. -->
          <ngx-datatable-column
            *ngIf="!requestFlow"
            prop="zone"
            [width]="66"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Zona</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.zone || "—" }}
            </ng-template>
          </ngx-datatable-column>

          <!-- Estado (entidad federativa de la estación): SOLO en el cronograma del
               Tablero, para el admin MOBICO o el grupo solicitante MOBICO (acompaña al
               filtro de Estado del header; los demás grupos no tienen entidad_id
               poblado y verían puros "—"). frozenLeft para mantener contiguo el
               bloque congelado. -->
          <ngx-datatable-column
            *ngIf="!requestFlow && (isMobicoAdmin || isMobicoRequester)"
            prop="entidad_id"
            [width]="72"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Estado</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ stateLabel(row.entidad_id) }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            prop="product"
            [width]="62"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Producto</span>
            </ng-template>
            <!-- Badge soft-tint (task 2026-07-09, espejo del badge de Estatus)
                 conservando la identidad de color de producto del portal:
                 regular verde, premium rojo, diésel oscuro; total/otros en el
                 gris neutro base del pill. -->
            <!-- Flujo MOBICO (source=orders, revisión 06-oct): el MISMO chip de
                 producto de Solicitudes (mobil-*, nombres Extra/Supreme/Diésel),
                 para que las tablas del flujo se lean igual. -->
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="source === 'orders' && row.product; else portalProductBadge"
                class="pipes-suggest__product"
                [ngClass]="'mobil-' + row.product"
                >{{ productLabel(row.product) }}</span
              >
              <ng-template #portalProductBadge>
                <span
                  class="status-label text-capitalize"
                  [ngClass]="{
                    'product-regular': row.product === 'regular',
                    'product-premium': row.product === 'premium',
                    'product-diesel': row.product === 'diesel',
                  }"
                >
                  {{ row.product }}
                </span>
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <!-- frozenLeft: va entre Producto y Material, ambos congelados; sin
               congelarla ngx-datatable la pintaría después de todo el bloque fijo. -->
          <ngx-datatable-column
            prop="date"
            [width]="56"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Fecha de<br />Solicitud</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <!-- En solicitudes la fecha es un timestamp real → hora de México (-0600) -->
              {{
                row.date
                  | date
                    : "dd/MM/yy"
                    : (source === "orders" ? "-0600" : "+0000")
                    : "es"
              }}
            </ng-template>
          </ngx-datatable-column>

          <!-- Material capturado en la solicitud: concepto interno de MOBICO (junta 16-oct),
               solo lo ve su admin; la estación trabaja con el Tipo. -->
          <ngx-datatable-column
            *ngIf="isMobicoAdmin"
            prop="material"
            [width]="106"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Material</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span class="material-cell" [title]="row.material || ''">{{
                row.material || "—"
              }}</span>
            </ng-template>
          </ngx-datatable-column>


          <!-- Comerc, Turno y Fecha y Hora Actualización se ELIMINARON del cronograma
               (task 2026-07-09 "eliminar campos innecesarios": aplica al flujo MOBICO
               Y al cronograma legacy de Inventario, confirmado por el equipo). -->

          <ngx-datatable-column
            prop="liters_requested"
            [width]="62"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Litros<br />Solicitados</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.liters_requested | number: "1.0-0" }}
            </ng-template>
          </ngx-datatable-column>

          <!-- La columna Estatus se ELIMINÓ también del cronograma del Tablero
               (task 2026-07-14; en el flujo ya no existía desde 2026-07-10). La
               banda del Tablero tampoco tiene filtro de Estatus (se quitó el
               2026-07-10: mezclaba estatus de fuel-orders con ObjectIds del
               catálogo purchase_status y vaciaba la tabla). -->


          <!-- prop = el campo que la celda PINTA (antes ambas columnas de fecha
               ordenaban por status_date, que no es lo que muestran). -->
          <ngx-datatable-column
            prop="expected_delivery_date"
            [width]="56"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Fecha<br />Requerida</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{
                row.expected_delivery_date | date: "dd/MM/yy" : "+0000" : "es"
              }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            prop="delivery_date"
            [width]="56"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Fecha de<br />Entrega</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{
                row.delivery_date
                  ? (row.delivery_date | date: "dd/MM/yy" : "+0000" : "es")
                  : "—"
              }}
            </ng-template>
          </ngx-datatable-column>

          <!-- Estatus del viaje (Excel de ENTREGAS de la transportadora, cargado por
               PROCESSES_MX/save-mobico-orders): dónde va la pipa — pendiente, en
               terminal, cargando, en ruta, entregada, cancelada. Solo en el flujo
               de pedidos (source=orders): las compras del Tablero legacy no lo
               traen. Tooltip = hora de llegada / cuándo se reportó. El pill se
               ellipsa (.delivery-status) para no romper el presupuesto de anchos;
               en este flujo no se pintan Zona ni Estado, así que la suma sigue
               bajo el presupuesto sin scroll horizontal. Se rotula «Estatus del
               viaje» y no «MOBICO» (revisión 06-oct): «Respuesta MOBICO» ya es la
               aprobación del admin; este es el estado del viaje que reporta CEPSA. -->
          <!-- 78 → 104 (revisión 08-oct): con 78 los chips "Entregada" / "En
               estación" se cortaban con "…"; 104 cabe la etiqueta más larga del
               catálogo ("En estación", "Sin estatus") sin recorte. -->
          <ngx-datatable-column
            *ngIf="source === 'orders'"
            prop="delivery_status"
            [width]="104"
            [minWidth]="104"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Estatus<br />del viaje</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="row.delivery_status; else noDeliveryStatus"
                class="status-label delivery-status"
                [ngClass]="deliveryStatusClass(row)"
                [title]="deliveryStatusTitle(row)"
                >{{ deliveryStatusLabel(row) }}</span
              >
              <ng-template #noDeliveryStatus>
                <span class="mobico-response" title="Aún no hay estatus del viaje de esta pipa">—</span>
              </ng-template>
            </ng-template>
          </ngx-datatable-column>

          <!-- Fecha de Registro: cuándo la ESTACIÓN ingresó el producto en su
               volumetría (la captura el solicitante con el botón Registrar).
               Evento DISTINTO a la entrega: la entrega alimenta la planeación;
               el registro solo documenta el ingreso. En el Tablero solo las
               compras nacidas de un pedido MOBICO pueden traerla (—  en manuales). -->
          <ngx-datatable-column
            prop="registration_date"
            [width]="56"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Fecha de<br />Registro</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{
                row.registration_date
                  ? (row.registration_date | date: "dd/MM/yy" : "+0000" : "es")
                  : "—"
              }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            prop="liters"
            [width]="62"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Litros<br />Entregados</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.liters != null ? (row.liters | number: "1.0-0") : "—" }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            prop="total"
            [width]="56"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span title="No incluye IVA, ni descuento"
                >Costo<br />Total
                <i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                  style="color: #9b9b9b"
                ></i
              ></span>
            </ng-template>
            <!-- Sin costo = por definir (junta 27-oct): MOBICO ya no lo captura al aprobar. -->
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span [title]="row.total != null ? '' : 'Por definir'">{{
                row.total != null ? "$ " + (row.total | number: "1.0-0") : "—"
              }}</span>
            </ng-template>
          </ngx-datatable-column>

          <!-- En modo solicitudes Costo Litro cierra el borde derecho SALVO cuando
               hay columna Acciones después: admin MOBICO (Editar) o estación en el
               flujo (Registrar volumetría). La col. Fecha y Hora Actualización que
               lo cerraba antes se eliminó, task 2026-07-09. -->
          <ngx-datatable-column
            prop="supply_price"
            [width]="40"
            [cellClass]="
              source === 'orders' && !isMobicoAdmin && !canRegisterVolumetria
                ? 'right-side'
                : ''
            "
            [headerClass]="
              source === 'orders' && !isMobicoAdmin && !canRegisterVolumetria
                ? 'top-side right-side'
                : 'top-side'
            "
          >
            <ng-template ngx-datatable-header-template>
              <span>Costo<br />Litro</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span [title]="row.supply_price != null ? '' : 'Por definir'">{{
                row.supply_price != null
                  ? "$ " + (row.supply_price | number: "1.2-2")
                  : "—"
              }}</span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Acciones del cronograma: el admin MOBICO edita la entrega DIRECTO
                     (fecha real y costos, sin flujo de aprobación y sin opción de
                     eliminar); la ESTACIÓN captura su fecha de registro en
                     volumetría. -->
          <!-- Edición SEGMENTADA a admins MOBICO; también en el Cronograma del
               Tablero (compras sin source, fix 2026-07-13): ahí solo las filas
               nacidas de un pedido llevan botón (deliveryEditable). El Registrar
               de la estación aplica en el cronograma del flujo Y en el del
               Tablero (task 2026-07-14, gate canRegisterBoard = grupo solicitante;
               en el Tablero solo filas fuel_order:*, como el Editar). -->
          <ngx-datatable-column
            *ngIf="isMobicoAdmin || canRegisterVolumetria || canRegisterBoard"
            name="Acciones"
            [width]="80"
            [minWidth]="76"
            [sortable]="false"
            [cellClass]="'right-side'"
            [headerClass]="'top-side right-side'"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <!-- «Cambiar» del admin (Edey 19-oct): el MISMO botón y modal que en la
                   tabla Solicitudes del panel admin (antes «Editar» con un diálogo
                   propio). El registro de la estación NO lo bloquea (2026-07-20);
                   solo una pipa que ya llegó. Siempre visible con enable/disable. -->
              <button
                *ngIf="deliveryEditable(row)"
                type="button"
                class="row-action-btn green"
                [disabled]="!canAdminChange(row)"
                [title]="adminChangeDisabledReason(row) || 'Cambiar producto, fecha de entrega, litros o costos de este pedido'"
                (click)="openAdminChange(row)"
              >
                Cambiar
              </button>
              <!-- Un pedido ya registrado NO se vuelve a registrar (decisión
                   2026-07-14): botón siempre visible con enable/disable y
                   tooltip del motivo — mismo patrón que Cambiar/Cancelar. -->
              <button
                *ngIf="showRegisterFor(row)"
                type="button"
                class="row-action-btn green"
                [disabled]="!!row.registration_date"
                [title]="
                  row.registration_date
                    ? 'Registrado el ' + (row.registration_date | date: 'dd/MM/yy' : '+0000' : 'es')
                    : 'Registrar el ingreso del producto en volumetría'
                "
                (click)="openRegistro(row)"
              >
                Registrar
              </button>
              <span
                class="mobico-response"
                *ngIf="!deliveryEditable(row) && !showRegisterFor(row)"
                >—</span
              >
            </ng-template>
          </ngx-datatable-column>

        </ngx-datatable>
        </div>
        <!-- Cargando: el esqueleto va DENTRO de la card (Edey 19-oct: al cambiar de semana la card
             se encogía a la banda y recortaba la lista del selector; afuera quedaba el esqueleto suelto). -->
        <div class="row" style="margin: 10px" *ngIf="reqst === 0">
          <app-table-loader style="width: 100%"></app-table-loader>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="modal-add"
  tabindex="-1"
  role="dialog"
  aria-labelledby="tableColumns"
  aria-hidden="true"
>
  <div class="modal-dialog medium-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-center" id="tableColumns">
          Ingresa los datos de la pipa
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body medium">
        <form [formGroup]="newForm">
          <div class="content">
            <label class="subtitle" for="station_name">
              <span>Estación</span>
            </label>
            <div *ngIf="showStations">
              <epy-select
                [options]="stations"
                placeholder="Seleccionar Estación"
                [value]="stationSelected"
                filter="true"
                filter-placeholder="Buscar Estación"
                not-found-copy="Sin resultados"
                (selectChange)="changeStation($event)"
              >
              </epy-select>
            </div>

            <label class="subtitle" for="product">
              <span>Producto</span>
            </label>
            <div>
              <epy-select
                [options]="products"
                placeholder="Seleccionar Producto"
                [value]="product"
                (selectChange)="changeProduct($event)"
              >
              </epy-select>
            </div>

            <label class="subtitle" for="marketSelected">
              <span>Comercializadora</span>
            </label>
            <div *ngIf="showMarketers">
              <epy-select
                [options]="marketers"
                placeholder="Seleccionar Comercializadora"
                [value]="marketSelected"
                filter="true"
                filter-placeholder="Buscar Comercializadora"
                not-found-copy="Sin resultados"
                (selectChange)="changeMarketer($event)"
              >
              </epy-select>
            </div>

            <label class="subtitle" for="total" *ngIf="marketerName === 'OTRA'">
              <span>Nombre de la Comercializadora</span>
            </label>
            <br *ngIf="marketerName === 'OTRA'" />
            <input
              maxLength="16"
              class="all"
              type="text"
              formControlName="marketOther"
              *ngIf="marketerName === 'OTRA'"
            />
            <br *ngIf="marketerName === 'OTRA'" />

            <label class="subtitle" for="shiftSelected">
              <span>Turno</span>
            </label>
            <div *ngIf="showWorkShifts">
              <epy-select
                [options]="workshifts"
                placeholder="Seleccionar Turno"
                [value]="shiftSelected"
                (selectChange)="changeShift($event)"
              >
              </epy-select>
            </div>

            <label class="subtitle" for="litersRequested">
              <span>Litros Solicitados</span>
            </label>
            <br />
            <input
              maxLength="6"
              class="all"
              type="text"
              formControlName="litersRequested"
              (keypress)="numberOnly($event)"
            />
            <br />

            <label class="subtitle" for="statusSelected">
              <span>Estatus</span>
            </label>
            <div *ngIf="showStatus">
              <epy-select
                [options]="status"
                placeholder="Seleccionar Estatus"
                [value]="statusSelected"
                (selectChange)="changeStatus($event)"
              >
              </epy-select>
            </div>

            <label class="subtitle" for="date">
              <span>Fecha de Solicitud</span>
            </label>
            <br />
            <input
              class="all"
              type="date"
              formControlName="date"
              min="2020-12-01"
              [max]="maxDate"
            />
            <br />

            <label class="subtitle" for="date">
              <span>Fecha Estimada de Entrega</span>
            </label>
            <br />
            <input
              class="all"
              type="date"
              formControlName="expectedDeliverateDate"
              min="2020-12-01"
              [max]="maxDate"
            />
            <br />

            <label
              class="subtitle"
              for="date"
              *ngIf="statusName === 'Cancelada'"
            >
              <span>Fecha de Cancelación</span>
            </label>
            <br *ngIf="statusName === 'Cancelada'" />
            <input
              class="all"
              type="date"
              formControlName="cancellationDate"
              min="2020-12-01"
              [max]="maxDate"
              *ngIf="statusName === 'Cancelada'"
            />
            <br *ngIf="statusName === 'Cancelada'" />

            <label
              class="subtitle"
              for="date"
              *ngIf="statusName === 'Entregada'"
            >
              <span>Fecha de Entrega</span>
            </label>
            <br *ngIf="statusName === 'Entregada'" />
            <input
              class="all"
              type="date"
              formControlName="deliverateDate"
              min="2020-12-01"
              [max]="maxDate"
              *ngIf="statusName === 'Entregada'"
            />
            <br *ngIf="statusName === 'Entregada'" />

            <label
              class="subtitle"
              for="litersRequested"
              *ngIf="statusName === 'Entregada'"
            >
              <span>Litros Entregados</span>
            </label>
            <br *ngIf="statusName === 'Entregada'" />
            <input
              maxLength="6"
              class="all"
              type="text"
              formControlName="liters"
              *ngIf="statusName === 'Entregada'"
              (keypress)="numberOnly($event)"
            />
            <br *ngIf="statusName === 'Entregada'" />

            <label class="subtitle" for="total">
              <span>Costo Total</span>
            </label>
            <br />
            <input
              maxLength="10"
              class="all"
              type="text"
              formControlName="total"
              (keypress)="numberOnly($event)"
            />
            <br />

            <label class="subtitle" for="statusDate">
              <span>Fecha de Actualización</span>
            </label>
            <br />
            <input
              class="all"
              type="date"
              disabled
              min="2020-12-01"
              [max]="max"
              [value]="max"
            />
          </div>
        </form>
      </div>
      <div class="footer-modal">
        <button
          type="button"
          class="add"
          data-dismiss="modal"
          (click)="addPipe()"
          *ngIf="mode === 'add'"
        >
          Agregar
        </button>
        <button
          type="button"
          class="add"
          data-dismiss="modal"
          (click)="addPipe()"
          *ngIf="mode === 'edit'"
        >
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal del INVENTARIO Real y Teórico (modalOnly): el MISMO formulario inline
     "Nueva solicitud" de la vista Solicitudes, dentro de un diálogo (feedback
     2026-07-16 "el modal no sigue los estilos de solicitudes"). La card la pinta
     .pipes-req__section; el modal-content va transparente y solo aporta ancho,
     centrado y el botón de cierre. -->
<div
  class="modal fade op-modal op-wide inv-order-modal"
  *ngIf="modalOnly"
  [class.show]="showOrderForm"
  [style.display]="showOrderForm ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  [attr.aria-hidden]="!showOrderForm"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <button
        type="button"
        class="close inv-order-modal__close"
        aria-label="Cerrar"
        (click)="cancelOrderForm()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <ng-container [ngTemplateOutlet]="newOrderStationForm"></ng-container>
    </div>
  </div>
</div>

<!-- Modal: nueva solicitud de pipa (fuel-orders, varias pipas por solicitud) -->
<div
  class="modal fade op-modal"
  *ngIf="!modalOnly"
  [class.show]="showOrderForm"
  [class.op-wide]="!onlyStation"
  [style.display]="showOrderForm ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="opTitle"
  [attr.aria-hidden]="!showOrderForm"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <!-- Desde "Pedir" / "Pedir todas" el título orienta a lo que falta:
             estación, producto, fecha y capacidad ya vienen de la sugerencia,
             el usuario solo captura PO y material (decisión junta 2026-07-31). -->
        <h5 class="modal-title" id="opTitle">
          {{
            orderEditMode
              ? "Editar solicitud de pipa"
              : suggestModalActive
                ? "Completar pedido sugerido"
                : "Nueva solicitud de pipa"
          }}
        </h5>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          (click)="cancelOrderForm()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- Una pipa por bloque; cada bloque es una fila estilo Excel. -->
        <div class="op-block" *ngFor="let f of orderForms; let i = index">
          <div class="op-head" *ngIf="!orderEditMode">
            <span class="op-title">Pipa {{ i + 1 }}</span>
            <!-- Patrón estándar de eliminar del portal (mismo ícono .icon.delete del
                             cronograma de esta pantalla). Siempre visible: deshabilitado con una sola pipa. -->
            <i
              class="fa fa-trash-o icon delete"
              aria-hidden="true"
              [class.disabled]="orderForms.length < 2"
              (click)="orderForms.length > 1 && removeOrderRow(i)"
              [title]="
                orderForms.length > 1
                  ? 'Eliminar pipa'
                  : 'La solicitud necesita al menos una pipa'
              "
            ></i>
          </div>
          <div class="op-row">
            <div class="op-field">
              <label>PO#</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="f.po"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="!editingOrderId"
                [placeholder]="editingOrderId ? 'Ej. PET8EX01' : 'Elige el tipo'"
              />
            </div>
            <div class="op-field">
              <label>Fecha requerida</label>
              <input
                type="date"
                class="form-control"
                [class.is-placeholder]="!f.loadDate"
                [class.is-invalid]="rowDateTooEarly(f)"
                [min]="minRequestDate"
                [title]="rowDateTooEarly(f) ? minRequestDateTitle : ''"
                [(ngModel)]="f.loadDate"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="updateRowSpace(f)"
              />
            </div>
            <!-- Estación: solo en modo grupo (en estación es implícita). Va después de
                             Fecha requerida, como el formato MOBICO (PO · FECHA REQUERIDA · ESTACIÓN).
                             ngx-select (mismo componente buscable que los selectores de Zona): se escribe el nombre y filtra. -->
            <div class="op-field op-field-station" *ngIf="!onlyStation">
              <label>Estación</label>
              <!-- appendTo body: el desplegable se renderiza fuera del cuerpo con scroll
                                 para que el scroll interno del modal no lo recorte. -->
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="stations"
                optionValueField="value"
                optionTextField="label"
                placeholder="Selecciona…"
                appendTo="body"
                [dropDownMenuOtherClasses]="'op-appended-dropdown'"
                [(ngModel)]="f.station"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="updateRowSpace(f)"
              >
                <ng-template ngx-select-option-not-found let-input>
                  "{{ input }}" no encontrada
                </ng-template>
              </ngx-select>
            </div>
            <div class="op-field op-field-capacity">
              <label>Capacidad</label>
              <!-- Campo libre con separador de miles para admin Y solicitante (Edey 20-oct;
                   antes el solicitante elegía de 5,000 en 5,000). Si la estación tiene
                   capacidades permitidas cargadas, el API rechaza las demás con su mensaje. -->
              <input
                type="text"
                inputmode="numeric"
                class="form-control"
                (keypress)="numberOnly($event)"
                [class.over-space]="rowOverSpace(f)"
                [ngModel]="formatThousands(f.capacity)"
                (ngModelChange)="f.capacity = parseThousands($event)"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Ej. 30,000"
              />
              <!-- Candado de inventario: espacio del tanque proyectado a la fecha requerida.
                                 Pills de una línea apilados dentro de la columna (min-width en
                                 .op-field-capacity garantiza que quepan sin envolver). -->
              <small class="space-hint muted" *ngIf="f.spaceLoading">
                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                Consultando espacio…
              </small>
              <!-- El pill rojo ES el botón del desglose (2026-07-13 v2 "sin
                   ampliar más"): click abre "¿Por qué no hay espacio?". -->
              <small
                class="space-hint"
                [class.over]="rowOverSpace(f)"
                *ngIf="!f.spaceLoading && f.availableSpace != null"
                (click)="rowOverSpace(f) && openSpaceInfo(f)"
                [title]="
                  rowOverSpace(f)
                    ? 'Ver por qué no hay espacio'
                    : f.spaceBasis === 'theoretical'
                      ? 'Espacio a la fecha de entrega: capacidad del tanque menos inventario TEÓRICO del día (el mismo del Cronograma) y arrastre'
                      : 'Espacio a la fecha de entrega: capacidad del tanque menos la lectura real del volumétrico y arrastre'
                "
              >
                <i
                  class="fa"
                  [ngClass]="
                    rowOverSpace(f) ? 'fa-exclamation-triangle' : 'fa-tint'
                  "
                  aria-hidden="true"
                ></i>
                <span>
                  <ng-container *ngIf="!rowOverSpace(f)"
                    >Espacio disp.
                    {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                  >
                  <ng-container *ngIf="rowOverSpace(f) && rowEffectiveSpace(f)"
                    >Excede máx.
                    {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                  >
                  <ng-container *ngIf="rowOverSpace(f) && !rowEffectiveSpace(f)"
                    >Sin espacio disponible</ng-container
                  >
                  <i
                    class="fa fa-question-circle space-hint__q"
                    *ngIf="rowOverSpace(f)"
                    aria-hidden="true"
                  ></i>
                </span>
              </small>
              <small
                class="space-hint muted"
                *ngIf="
                  !f.spaceLoading && f.spaceChecked && f.availableSpace == null
                "
                title="La estación no tiene capacidad de tanque o lectura de inventario para este producto"
              >
                <i class="fa fa-info-circle" aria-hidden="true"></i> Sin datos
                de inventario
              </small>
            </div>
            <div class="op-field">
              <label>Producto</label>
              <!-- ngx-select con tag de color por producto (pedido 2026-07-31),
                   mismo trato que el campo Estación de este modal; el chip es el
                   mobil-* de la lista de sugerencias. Sin buscador (3 opciones). -->
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [noAutoComplete]="true"
                [items]="orderProductOptions"
                optionValueField="value"
                optionTextField="label"
                placeholder="Selecciona…"
                appendTo="body"
                [dropDownMenuOtherClasses]="'op-appended-dropdown'"
                [(ngModel)]="f.product"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="updateRowSpace(f)"
              >
                <ng-template ngx-select-option let-option>
                  <span
                    class="pipes-suggest__product"
                    [ngClass]="'mobil-' + option.value"
                    >{{ option.text }}</span
                  >
                </ng-template>
                <ng-template ngx-select-option-selected let-option>
                  <span
                    class="pipes-suggest__product"
                    [ngClass]="'mobil-' + option.value"
                    >{{ option.text }}</span
                  >
                </ng-template>
              </ngx-select>
            </div>
            <!-- Material ya no se captura (junta MOBICO 16-oct): concepto interno de MOBICO. -->
          </div>
        </div>

        <!-- Mismo patrón "Agregar +" del portal (reporte de compras, new-report-ope):
                     texto en negritas + fa-plus verde text-success. -->
        <button
          type="button"
          class="op-add-more"
          *ngIf="!orderEditMode"
          (click)="addOrderRow()"
        >
          Añadir pipa <i class="fa fa-plus text-success" aria-hidden="true"></i>
        </button>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link op-cancel" (click)="cancelOrderForm()">
          Cancelar
        </button>
        <button
          class="op-btn"
          (click)="submitOrderForm()"
          [disabled]="!orderFormValid || savingOrder"
        >
          {{
            savingOrder ? "Guardando…" : orderEditMode ? "Guardar" : "Enviar"
          }}
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal-backdrop fade show"
  *ngIf="showOrderForm"
  (click)="cancelOrderForm()"
></div>

<!-- Modal: realizar cambio sobre un pedido (solicitud de cambio a MOBICO; el pedido
     original se modifica hasta que MOBICO la aprueba en su panel) -->
<div
  class="modal fade op-modal op-wide op-confirm"
  [class.show]="showChangeForm"
  [style.display]="showChangeForm ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="changeTitle"
  [attr.aria-hidden]="!showChangeForm"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <!-- Mismo header de "Aprobar solicitud" (op-confirm): ícono en círculo + título -->
        <div class="confirm-icon" aria-hidden="true">
          <img src="/assets/icons/alert-confirm.svg" alt="" width="26" height="26" />
        </div>
        <h5 class="modal-title" id="changeTitle">Realizar cambio</h5>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          (click)="cancelChangeForm()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- Tipo de cambio arriba, separado del formato -->
        <div class="op-row op-change-type">
          <div class="op-field">
            <label>Tipo de cambio</label>
            <select
              class="form-control"
              [(ngModel)]="changeForm.type"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="refreshChangeSpace(); refreshChangeDeadline()"
            >
              <option *ngFor="let t of changeTypeOptions" [value]="t.value">
                {{ t.label }}
              </option>
            </select>
          </div>
        </div>

        <!-- Formato MOBICO en UNA sola línea: PO · Fecha requerida · Estación ·
                         Capacidad · Producto (solo lectura en gris) + el campo nuevo del tipo. -->
        <div class="op-row">
          <div class="op-field">
            <label>PO#</label>
            <input
              type="text"
              class="form-control"
              [value]="changeRow?.po_number || '—'"
              disabled
            />
          </div>
          <div class="op-field">
            <label>Fecha requerida</label>
            <input
              type="text"
              class="form-control"
              [value]="
                currentDeliveryDate(changeRow)
                  ? (currentDeliveryDate(changeRow)
                    | date: 'dd/MM/yy' : '+0000' : 'es')
                  : '—'
              "
              disabled
            />
          </div>
          <!-- Reparto 2026-07-13: Estación y el campo nuevo llevan 1.5× (los que
               más texto cargan); Producto cede su doble ancho (los materiales
               largos truncan con ellipsis, el valor completo vive en la tabla). -->
          <div class="op-field op-field-wide">
            <label>Estación</label>
            <input
              type="text"
              class="form-control"
              [value]="changeRow?.station_name || '—'"
              disabled
            />
          </div>
          <div class="op-field">
            <label>Capacidad</label>
            <input
              type="text"
              class="form-control"
              [value]="
                capacityValue(changeRow)
                  ? (capacityValue(changeRow) | number: '1.0-0')
                  : '—'
              "
              disabled
            />
          </div>
          <div class="op-field">
            <label>Producto</label>
            <input
              type="text"
              class="form-control"
              [value]="changeRow?.product ? productLabel(changeRow.product) : '—'"
              disabled
            />
          </div>
          <div class="op-field op-field-wide" *ngIf="changeForm.type === 'date'">
            <label>Nueva fecha</label>
            <input
              type="text"
              class="form-control cal-input"
              readonly
              placeholder="Selecciona la fecha"
              [value]="
                changeForm.newDate
                  ? (changeForm.newDate | date: 'dd/MM/yy' : '+0000' : 'es')
                  : ''
              "
              (click)="toggleChangeCalendar($event)"
            />
          </div>
          <div class="op-field op-field-wide" *ngIf="changeForm.type === 'capacity'">
            <label>Nueva capacidad</label>
            <!-- Campo libre con separador de miles para admin Y solicitante (Edey 20-oct;
                 antes el solicitante elegía de 5,000 en 5,000). Si la estación tiene
                 capacidades permitidas cargadas, el API rechaza las demás con su mensaje. -->
            <input
              type="text"
              inputmode="numeric"
              class="form-control"
              (keypress)="numberOnly($event)"
              [class.over-space]="changeOverSpace"
              [ngModel]="formatThousands(changeForm.newCapacity)"
              (ngModelChange)="changeForm.newCapacity = parseThousands($event)"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Ej. 30,000"
            />
          </div>
          <div class="op-field op-field-wide" *ngIf="changeForm.type === 'product'">
            <label>Nuevo producto</label>
            <select
              class="form-control"
              [class.is-placeholder]="!changeForm.newProduct"
              [(ngModel)]="changeForm.newProduct"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="refreshChangeSpace()"
            >
              <option value="" disabled selected>Selecciona…</option>
              <option *ngFor="let p of orderProductOptions" [value]="p.value">
                {{ p.label }}
              </option>
            </select>
          </div>
          <!-- «Nuevo material» ya no se captura (junta MOBICO 16-oct): el cambio es solo de Tipo. -->
        </div>
        <!-- Calendario del cambio de fecha ANCLADO bajo el campo "Nueva fecha"
                         (task 2026-07-10, iteración: "que aparezca abajo de Nueva fecha, como el
                         picker nativo de Fecha requerida"): capa fija transparente que atrapa el
                         click-fuera + panel posicionado junto al input (calPanelPos, calculado al
                         abrir). Conserva el estilo del picker (fecha actual gris no seleccionable,
                         nueva en verde); elegir un día lo cierra (onCalSelect). Capa fija: no lo
                         recorta el overflow:hidden del .modal-content ni empuja el layout. -->
        <div
          class="op-cal-overlay"
          *ngIf="changeForm.type === 'date' && showChangeCalendar"
          (click)="showChangeCalendar = false"
        >
        <div
          class="op-mini-cal op-mini-cal--modal"
          [ngStyle]="calPanelPos"
          (click)="$event.stopPropagation()"
        >
          <!-- footerTemplate: la leyenda de colores vive DENTRO de la tarjeta del
                           propio datepicker (pedido 2026-07-10: sin card contenedora extra,
                           pero el significado de cada color sí es importante). -->
          <ngb-datepicker
            [startDate]="calStartDate"
            [minDate]="calMinDate"
            navigation="arrows"
            [markDisabled]="calMarkDisabled"
            [dayTemplate]="calDay"
            [footerTemplate]="calFooter"
            (dateSelect)="onCalSelect($event)"
          ></ngb-datepicker>
          <ng-template #calFooter>
            <div class="cal-legend">
              <span class="cal-dot current"></span> Fecha actual
              <span class="cal-dot selected"></span> Nueva fecha
            </div>
          </ng-template>
          <ng-template
            #calDay
            let-date
            let-currentMonth="currentMonth"
            let-disabled="disabled"
          >
            <span
              class="cal-day"
              [class.cal-outside]="date.month !== currentMonth"
              [class.cal-disabled]="disabled"
              [class.cal-current]="isCalCurrent(date)"
              [class.cal-selected]="isCalSelected(date)"
              >{{ date.day }}</span
            >
          </ng-template>
          <!-- La leyenda "Fecha actual / Nueva fecha" se retiró junto con la card
                           contenedora (feedback 2026-07-10 "solo deja el picker"): flotaría
                           suelta sobre el fondo sin la tarjeta que la sostenía. -->
        </div>
        </div>
        <!-- Candado de inventario: espacio del tanque con los valores del cambio -->
        <small class="space-hint muted" *ngIf="changeSpaceLoading">
          <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
          Consultando espacio…
        </small>
        <!-- El pill rojo ES el botón del desglose (2026-07-13 v2 "sin ampliar
             más"): click abre "¿Por qué no hay espacio?". -->
        <small
          class="space-hint"
          [class.over]="changeOverSpace"
          *ngIf="!changeSpaceLoading && changeSpace != null"
          (click)="changeOverSpace && openChangeSpaceInfo()"
          [title]="
            changeOverSpace
              ? 'Ver por qué no hay espacio'
              : changeSpaceBasis === 'theoretical'
                ? 'Espacio a la fecha de entrega: capacidad del tanque menos inventario TEÓRICO del día (el mismo del Cronograma) y arrastre'
                : 'Espacio a la fecha de entrega: capacidad del tanque menos la lectura real del volumétrico y arrastre'
          "
        >
          <i
            class="fa"
            [ngClass]="changeOverSpace ? 'fa-exclamation-triangle' : 'fa-tint'"
            aria-hidden="true"
          ></i>
          <span>
            <ng-container *ngIf="!changeOverSpace"
              >Espacio disp.
              {{ changeSpace | number: "1.0-0" }} lts.</ng-container
            >
            <ng-container *ngIf="changeOverSpace && changeSpace"
              >Excede máx.
              {{ changeSpace | number: "1.0-0" }} lts.</ng-container
            >
            <ng-container *ngIf="changeOverSpace && !changeSpace"
              >Sin espacio disponible</ng-container
            >
            <i
              class="fa fa-question-circle space-hint__q"
              *ngIf="changeOverSpace"
              aria-hidden="true"
            ></i>
          </span>
        </small>
        <small
          class="space-hint muted"
          *ngIf="
            !changeSpaceLoading && changeSpaceChecked && changeSpace == null
          "
          title="La estación no tiene capacidad de tanque o lectura de inventario para este producto"
        >
          <i class="fa fa-info-circle" aria-hidden="true"></i> Sin datos de
          inventario
        </small>
        <!-- Pedido ya confirmado: el cambio también pasa por la aprobación de MOBICO. -->
        <small class="space-hint muted" *ngIf="changeRow?.status === 'confirmed'">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          Pedido ya confirmado por MOBICO: el cambio necesita su aprobación; mientras responde sigue vigente la pipa confirmada.
        </small>
        <!-- Candado de 24 hrs (MOBICO 27-oct): el servidor dice si el cambio ya no se admite y se bloquea el envío. -->
        <small class="space-hint over" *ngIf="changeTooLate">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          {{ changeTooLateMsg }}
        </small>
      </div>
      <div class="modal-footer">
        <button class="confirm-btn gray" (click)="cancelChangeForm()">
          Cancelar
        </button>
        <button
          class="confirm-btn green"
          (click)="submitChangeForm()"
          [disabled]="!changeFormValid || savingChange"
        >
          {{ savingChange ? "Enviando…" : "Enviar solicitud" }}
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal-backdrop fade show"
  *ngIf="showChangeForm"
  (click)="cancelChangeForm()"
></div>

<!-- «Cambiar» del admin MOBICO desde el cronograma (Edey 19-oct): modal REAL del
     panel admin en una instancia modalOnly (misma mecánica que Inventario / Análisis
     de Pedido con los chips de pendientes). Se crea al vuelo y se destruye al cerrar. -->
<app-pipes-admin *ngIf="adminChangeOpen" [modalOnly]="true" (modalClosed)="onAdminChangeClosed($event)"></app-pipes-admin>

<!-- Registro en volumetría (ESTACIÓN, cronograma del flujo): captura la fecha en
     que se ingresó el producto en volumetría. Evento DISTINTO a la entrega (que
     alimenta la planeación): esto solo documenta el ingreso. Mismo chrome que
     "Editar entrega" (op-confirm) en versión compacta de una línea. -->
<div
  class="modal fade op-modal op-confirm"
  [class.show]="!!registroRow"
  [style.display]="registroRow ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="registroTitle"
  [attr.aria-hidden]="!registroRow"
>
  <div class="modal-dialog op-registro-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="confirm-icon" aria-hidden="true">
          <img src="/assets/icons/alert-confirm.svg" alt="" width="26" height="26" />
        </div>
        <h5 class="modal-title" id="registroTitle">Registrar en volumetría</h5>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          (click)="cancelRegistro()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="registroRow">
        <div class="op-row">
          <div class="op-field">
            <label>PO</label>
            <input
              type="text"
              class="form-control"
              [value]="registroRow.po_number || '—'"
              disabled
            />
          </div>
          <div class="op-field op-field-wide">
            <label>Estación</label>
            <input
              type="text"
              class="form-control"
              [value]="registroRow.station_name || ''"
              disabled
            />
          </div>
          <!-- Producto LEGIBLE (Regular/Premium/Diesel) y Material aparte, igual
               que las columnas de la tabla — antes un solo campo "Producto"
               mostraba el material y confundía (feedback 2026-07-14). -->
          <div class="op-field">
            <label>Producto</label>
            <input
              type="text"
              class="form-control"
              [value]="(registroRow.product | titlecase) || ''"
              disabled
            />
          </div>
          <div class="op-field op-field-wide" *ngIf="isMobicoAdmin">
            <label>Material</label>
            <input
              type="text"
              class="form-control"
              [value]="registroRow.material || '—'"
              [title]="registroRow.material || ''"
              disabled
            />
          </div>
          <!-- Fecha de entrega como referencia: el registro se captura respecto
               a cuándo llegó la pipa (es también el mínimo del calendario). -->
          <div class="op-field">
            <label>Fecha de entrega</label>
            <input
              type="text"
              class="form-control"
              [value]="
                registroRow.delivery_date
                  ? (registroRow.delivery_date | date: 'dd/MM/yy' : '+0000' : 'es')
                  : '—'
              "
              disabled
            />
          </div>
          <div class="op-field op-field-wide">
            <label for="registroDate">Fecha de registro</label>
            <input
              id="registroDate"
              type="text"
              class="form-control cal-input"
              readonly
              placeholder="Selecciona la fecha"
              [value]="
                registroDate
                  ? (registroDate | date: 'dd/MM/yy' : '+0000' : 'es')
                  : ''
              "
              (click)="toggleRegistroCal($event)"
            />
          </div>
        </div>
        <!-- Calendario flotante: solo tope MÁXIMO = hoy (decisión final
             2026-07-14) — el registro documenta algo que ya pasó: nada a
             futuro y backdateo libre de olvidos. La entrega NO es mínimo (la
             confirmada no siempre es la llegada real); queda como referencia
             gris. -->
        <div
          class="op-cal-overlay"
          *ngIf="showRegistroCal"
          (click)="showRegistroCal = false"
        >
          <div
            class="op-mini-cal op-mini-cal--modal"
            [ngStyle]="registroCalPos"
            (click)="$event.stopPropagation()"
          >
            <ngb-datepicker
              [startDate]="registroCalStartDate"
              navigation="arrows"
              [dayTemplate]="registroCalDay"
              [footerTemplate]="registroCalFooter"
              (dateSelect)="onRegistroCalSelect($event)"
            ></ngb-datepicker>
            <ng-template #registroCalFooter>
              <div class="cal-legend">
                <span class="cal-dot current"></span> Fecha de entrega
                <span class="cal-dot selected"></span> Fecha de registro
              </div>
            </ng-template>
            <ng-template
              #registroCalDay
              let-date
              let-currentMonth="currentMonth"
              let-disabled="disabled"
            >
              <span
                class="cal-day"
                [class.cal-outside]="date.month !== currentMonth"
                [class.cal-disabled]="disabled"
                [class.cal-current]="isRegistroCalDelivery(date)"
                [class.cal-selected]="isRegistroCalSelected(date)"
                >{{ date.day }}</span
              >
            </ng-template>
          </div>
        </div>
        <p class="op-direct-note">
          El registro documenta cuándo ingresaste el producto en volumetría; no
          modifica la fecha de entrega ni la planeación.
        </p>
        <p class="confirm-error" *ngIf="registroError">
          {{ registroError }}
        </p>
      </div>
      <div class="modal-footer">
        <button
          class="confirm-btn gray"
          (click)="cancelRegistro()"
          [disabled]="savingRegistro"
        >
          Cancelar
        </button>
        <button
          class="confirm-btn green"
          (click)="submitRegistro()"
          [disabled]="!registroValid || savingRegistro"
        >
          {{ savingRegistro ? "Guardando…" : "Guardar registro" }}
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal-backdrop fade show"
  *ngIf="registroRow"
  (click)="cancelRegistro()"
></div>

<!-- Modal de confirmación de cancelación: anatomía del custom-alert REAL del portal
     (header neutro, ícono auto-coloreado, título oscuro), texto simple con el PO,
     error inline. Botones como en todo el portal: gris cerrar, verde confirmar.
     Las respuestas de MOBICO se avisan con toast (showToast). -->
<div
  class="modal fade op-modal op-confirm"
  [class.show]="!!cancelTarget"
  [style.display]="cancelTarget ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="cancelTitle"
  [attr.aria-hidden]="!cancelTarget"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <!-- Ícono en círculo translúcido, como los custom-alert del portal. -->
        <div class="confirm-icon" aria-hidden="true">
          <img
            src="/assets/icons/alert-confirm.svg"
            alt=""
            width="26"
            height="26"
          />
        </div>
        <h5 class="modal-title" id="cancelTitle">Cancelar solicitud</h5>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          (click)="closeCancelConfirm()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="cancelTarget">
        <!-- Sujeto protagonista (chip + PO + estación) y consecuencia en tenue -->
        <div class="confirm-subject">
          <span class="type-chip" [ngClass]="cancelTarget.change_kind">{{
            cancelTarget.type_label
          }}</span>
          <span
            >PO {{ cancelTarget.po_number || "—" }} ·
            {{ cancelTarget.station_name || "" }}</span
          >
        </div>
        <p class="confirm-note">
          Se enviará a MOBICO la solicitud de cancelación y aplicará cuando la
          apruebe.
        </p>
        <p class="confirm-note" *ngIf="cancelTarget.status === 'confirmed'">
          El pedido ya está confirmado por MOBICO: la cancelación necesita su aprobación; mientras responde sigue vigente la pipa.
        </p>
        <p class="confirm-error" *ngIf="cancelError">{{ cancelError }}</p>
      </div>
      <div class="modal-footer">
        <button
          class="confirm-btn gray"
          (click)="closeCancelConfirm()"
          [disabled]="cancellingOrder"
        >
          Cerrar
        </button>
        <button
          class="confirm-btn green"
          (click)="confirmCancelOrder()"
          [disabled]="cancellingOrder"
        >
          {{ cancellingOrder ? "Enviando…" : "Solicitar cancelación" }}
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal-backdrop fade show"
  *ngIf="cancelTarget"
  (click)="closeCancelConfirm()"
></div>

<!-- Modal informativo: desglose de POR QUÉ no hay espacio para la pipa capturada
     (task 2026-07-13 "modal de información de por qué no me deja comprar").
     Misma anatomía op-confirm del flujo; solo lectura, un botón para cerrar.
     La cuenta espeja al candado: capacidad − inventario a la fecha de entrega
     (real o teórico del Cronograma) − arrastre − pipas de esta solicitud que
     llegan antes = espacio disponible vs. lo capturado. -->
<div
  class="modal fade op-modal op-confirm op-space-info"
  [class.show]="!!spaceInfo"
  [style.display]="spaceInfo ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="spaceInfoTitle"
  [attr.aria-hidden]="!spaceInfo"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="confirm-icon" aria-hidden="true">
          <img
            src="/assets/icons/alert-confirm.svg"
            alt=""
            width="26"
            height="26"
          />
        </div>
        <h5 class="modal-title" id="spaceInfoTitle">¿Por qué no hay espacio?</h5>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          (click)="closeSpaceInfo()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="spaceInfo">
        <div class="space-info">
          <div class="space-info__row">
            <span>Capacidad del tanque</span>
            <b>{{
              spaceInfo.tank != null
                ? (spaceInfo.tank | number: "1.0-0") + " lts."
                : "—"
            }}</b>
          </div>
          <div class="space-info__row">
            <span
              >− Inventario
              {{ spaceInfo.basis === "real" ? "real" : "teórico" }}
              {{
                spaceInfo.invDate
                  ? "al " + (spaceInfo.invDate | date: "dd/MM/yy" : "+0000" : "es")
                  : ""
              }}</span
            >
            <b>{{
              spaceInfo.inventory != null
                ? (spaceInfo.inventory | number: "1.0-0") + " lts."
                : "—"
            }}</b>
          </div>
          <div class="space-info__row" *ngIf="spaceInfo.carry">
            <span>− Arrastre del tanque</span>
            <b>{{ spaceInfo.carry | number: "1.0-0" }} lts.</b>
          </div>
          <div class="space-info__row" *ngIf="spaceInfo.batch">
            <span>− Lo que queda de las pipas de esta solicitud que llegan antes</span>
            <b>{{ spaceInfo.batch | number: "1.0-0" }} lts.</b>
          </div>
          <div class="space-info__row space-info__total">
            <span>= Espacio disponible</span>
            <b>{{
              spaceInfo.available != null
                ? (spaceInfo.available | number: "1.0-0") + " lts."
                : "—"
            }}</b>
          </div>
          <div
            class="space-info__row space-info__requested"
            *ngIf="spaceInfo.requested != null"
          >
            <span>Litros capturados</span>
            <b>{{ spaceInfo.requested | number: "1.0-0" }} lts.</b>
          </div>
        </div>
        <p class="confirm-note">
          Ajusta los litros o la fecha requerida para que la pipa quepa.
        </p>
      </div>
      <div class="modal-footer">
        <button class="confirm-btn green" (click)="closeSpaceInfo()">
          Entendido
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal-backdrop fade show op-space-backdrop"
  *ngIf="spaceInfo"
  (click)="closeSpaceInfo()"
></div>

<!-- "¿Por qué esta sugerencia?" (junta MOBICO 2026-07-27: "dónde ver todos los datos
     para la sugerencia"). Solo lectura. Contrasta el inventario proyectado a la
     fecha sugerida SIN pipa contra el mismo día CON la pipa: eso es exactamente
     lo que decidió el motor; los datos de abajo son los términos de esa cuenta.
     Rediseño 2026-07-31 ("parece de IA"): fuera el chrome op-confirm (banner
     verde + ícono en círculo) y las cajas pastel — header blanco de los modales
     de formulario del flujo y comparación en renglones estilo tabla con números
     alineados; el color queda en los DATOS (días en rojo bajo el mínimo,
     palomita cuando la pipa lo resuelve), no en el chrome. -->
<div
  class="modal fade op-modal op-suggest-why"
  [class.show]="!!whyRow"
  [style.display]="whyRow ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="suggestWhyTitle"
  [attr.aria-hidden]="!whyRow"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="suggestWhyTitle">¿Por qué esta sugerencia?</h5>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          (click)="closeWhy()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="whyRow">
        <div class="why-subject">
          <span class="pipes-suggest__product" [ngClass]="'mobil-' + whyRow.product">
            {{ whyRow.productLabel }}
          </span>
          <span>{{ whyRow.stationName }} · {{ whyRow.dateLabel }}</span>
        </div>

        <div class="why-table">
          <div class="why-table__head">
            <span></span>
            <span>Inventario</span>
            <span>Días</span>
          </div>
          <div class="why-table__row">
            <span class="why-table__label">Sin pedido · {{ whyRow.dateLabel }}</span>
            <span class="why-table__num">
              {{
                whyRow.inventoryBefore != null
                  ? (whyRow.inventoryBefore | number: "1.0-0") + " lts"
                  : "—"
              }}
            </span>
            <span
              class="why-table__num is-low"
              *ngIf="whyRow.daysBefore !== null; else sinDiasSin"
            >
              {{ whyRow.daysBefore | number: "1.1-1" }}
            </span>
            <ng-template #sinDiasSin><span class="why-table__num">—</span></ng-template>
          </div>
          <div class="why-table__row">
            <span class="why-table__label">
              <i class="fa fa-truck" aria-hidden="true"></i>
              Con la pipa sugerida · +{{ whyRow.liters | number: "1.0-0" }} lts
            </span>
            <span class="why-table__num">
              {{
                suggestInventoryAfter(whyRow) != null
                  ? (suggestInventoryAfter(whyRow) | number: "1.0-0") + " lts"
                  : "—"
              }}
            </span>
            <span
              class="why-table__num is-ok"
              *ngIf="whyRow.daysAfter !== null; else sinDiasCon"
            >
              {{ whyRow.daysAfter | number: "1.1-1" }} ✓
            </span>
            <ng-template #sinDiasCon><span class="why-table__num">—</span></ng-template>
          </div>
          <div class="why-table__foot">
            Mínimo configurado: {{ whyRow.thresholdDays }} días de inventario.
          </div>
        </div>

        <div class="why-terms-title">¿Cómo se calculó?</div>
        <div class="space-info">
          <div class="space-info__row">
            <span>
              Inventario hoy
              <ng-container *ngIf="whyRow.inventoryBasis === 'theoretical'">
                (teórico)
              </ng-container>
            </span>
            <b>{{
              whyRow.inventoryToday != null
                ? (whyRow.inventoryToday | number: "1.0-0") + " lts."
                : "—"
            }}</b>
          </div>
          <div class="space-info__row">
            <span>− Venta pronosticada (promedio hasta esa fecha)</span>
            <b>{{
              whyRow.dailySale != null
                ? (whyRow.dailySale | number: "1.0-0") + " lts./día"
                : "—"
            }}</b>
          </div>
        </div>
      </div>
      <!-- Botones de los modales de FORMULARIO del flujo (btn-link + op-btn),
           no los confirm-btn del chrome op-confirm que se retiró. -->
      <div class="modal-footer">
        <button class="btn btn-link op-cancel" (click)="closeWhy()">
          Cerrar
        </button>
        <!-- Mismo candado que el "Pedir" de la lista: si la pipa ya está en
             una solicitud abierta, este botón la duplicaría. -->
        <button
          class="op-btn"
          *ngIf="canUseSuggestion"
          [disabled]="isSuggestionQueued(whyRow)"
          [title]="
            isSuggestionQueued(whyRow)
              ? 'Esta pipa ya está en la solicitud'
              : ''
          "
          (click)="useSuggestion(whyRow)"
        >
          {{ isSuggestionQueued(whyRow) ? "Ya en la solicitud" : "Usar sugerencia" }}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Backdrop NORMAL, como los otros cinco modales que se abren desde la página.
     Llevaba .op-space-backdrop (z-index 1055), que existe solo para el desglose
     "¿Por qué no hay espacio?" porque ése se abre ENCIMA de otro modal: 1055
     supera al 1050 de .modal, y su diálogo sube a 1060 para compensar. Este
     modal no tiene modal padre y nunca subió a 1060, así que el backdrop le
     quedaba ENCIMA: atenuaba el propio diálogo (blanco 255 → 127 medido en la
     captura) y, peor, se comía los clics — "Usar sugerencia" y "Cerrar" caían
     en el backdrop, cuyo click cierra el modal. -->
<div class="modal-backdrop fade show" *ngIf="whyRow" (click)="closeWhy()"></div>

<!-- Formulario "Nueva solicitud" con Estación (compartido inline + modal del inventario;
     ver comentario en su punto de uso dentro del shell). -->
<ng-template #newOrderStationForm>
      <div
        class="pipes-req__section pipes-req__section--new pipes-req__section--with-station"
      >
        <h2 class="pipes-req__section-title">Nueva solicitud</h2>

        <!-- Header de labels compartido: mismas columnas que cada fila de pipa de abajo (sin caja). -->
        <div class="pipes-req__cols-head">
          <span>PO#</span>
          <span>Fecha requerida</span>
          <span>Estación</span>
          <span>Capacidad</span>
          <span>Producto</span>
          <span aria-hidden="true"></span>
        </div>

        <!-- Área con scroll propio en modo modal (feedback 2026-07-24: con
             "Usar todas" de la sugerencia el modal crecía más allá del
             viewport): las filas y "Agregar pipa" scrollean adentro; título,
             labels de columnas y "Enviar pedido" quedan siempre visibles. En el
             uso inline (Tablero) el wrapper no limita altura y no cambia nada. -->
        <!-- Itera inlineForms: en el uso INLINE del Tablero, con el modal de
             "Pedir" abierto orderForms son las pipas del modal y aquí debe
             seguir el borrador del usuario (feedback 2026-07-31). En el uso
             dentro del modal del inventario (modalOnly) no hay respaldo e
             inlineForms ES orderForms — cero cambio. -->
        <div class="pipes-req__rows-scroll">
        <div
          class="pipes-req__pipa"
          *ngFor="let f of inlineForms; let i = index"
        >
          <!-- De dónde salió esta solicitud (pedido 2026-07-29: "que se indique
               cuál es la solicitud"). Ocupa el ancho completo del grid, así que
               no descuadra las columnas ni en la variante con Estación. Es el
               otro extremo del chip "En la solicitud" de la lista de arriba:
               ahí se ve que la sugerencia ya bajó, acá cuál de todas es. -->
          <div class="pipes-req__pipa__origin" *ngIf="f.suggestLabel">
            <i class="fa fa-truck" aria-hidden="true"></i>
            Sugerencia de la semana · {{ f.suggestLabel }}
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">PO#</span>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="f.po"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="!editingOrderId"
              [placeholder]="editingOrderId ? 'Ej. PET8EX01' : 'Elige el tipo'"
            />
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Fecha requerida</span>
            <input
              type="date"
              class="form-control"
              [class.is-placeholder]="!f.loadDate"
              [class.is-invalid]="rowDateTooEarly(f)"
              [min]="minRequestDate"
              [title]="rowDateTooEarly(f) ? minRequestDateTitle : ''"
              [(ngModel)]="f.loadDate"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="updateRowSpace(f)"
            />
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Estación</span>
            <!-- appendTo body: el desplegable se renderiza fuera del cuerpo con scroll
                             para que el scroll de la página no lo recorte. -->
            <ngx-select
              class="op-ngx-select"
              [allowClear]="false"
              [items]="stations"
              optionValueField="value"
              optionTextField="label"
              placeholder="Selecciona…"
              appendTo="body"
              [dropDownMenuOtherClasses]="'op-appended-dropdown'"
              [(ngModel)]="f.station"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="updateRowSpace(f)"
            >
              <ng-template ngx-select-option-not-found let-input>
                "{{ input }}" no encontrada
              </ng-template>
            </ngx-select>
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Capacidad</span>
            <!-- Campo libre con separador de miles para admin Y solicitante (Edey 20-oct;
                 antes el solicitante elegía de 5,000 en 5,000). Si la estación tiene
                 capacidades permitidas cargadas, el API rechaza las demás con su mensaje. -->
            <input
              type="text"
              inputmode="numeric"
              class="form-control"
              (keypress)="numberOnly($event)"
              [class.over-space]="rowOverSpace(f)"
              [ngModel]="formatThousands(f.capacity)"
              (ngModelChange)="f.capacity = parseThousands($event)"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Ej. 30,000"
            />
            <!-- Candado de inventario: mismo mecanismo/copys que el modal multi-pipa. -->
            <small class="space-hint muted" *ngIf="f.spaceLoading">
              <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
              Consultando espacio…
            </small>
            <!-- El pill rojo ES el botón del desglose (2026-07-13 v2 "sin ampliar
                 más"): click abre el modal "¿Por qué no hay espacio?". -->
            <small
              class="space-hint"
              [class.over]="rowOverSpace(f)"
              *ngIf="!f.spaceLoading && f.availableSpace != null"
              (click)="rowOverSpace(f) && openSpaceInfo(f)"
              [title]="
                rowOverSpace(f)
                  ? 'Ver por qué no hay espacio'
                  : f.spaceBasis === 'theoretical'
                    ? 'Espacio a la fecha de entrega: capacidad del tanque menos inventario TEÓRICO del día (el mismo del Cronograma) y arrastre'
                    : 'Espacio a la fecha de entrega: capacidad del tanque menos la lectura real del volumétrico y arrastre'
              "
            >
              <i
                class="fa"
                [ngClass]="
                  rowOverSpace(f) ? 'fa-exclamation-triangle' : 'fa-tint'
                "
                aria-hidden="true"
              ></i>
              <span>
                <ng-container *ngIf="!rowOverSpace(f)"
                  >Espacio disp.
                  {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                >
                <ng-container *ngIf="rowOverSpace(f) && rowEffectiveSpace(f)"
                  >Excede máx.
                  {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                >
                <ng-container *ngIf="rowOverSpace(f) && !rowEffectiveSpace(f)"
                  >Sin espacio disponible</ng-container
                >
                <i
                  class="fa fa-question-circle space-hint__q"
                  *ngIf="rowOverSpace(f)"
                  aria-hidden="true"
                ></i>
              </span>
            </small>
            <small
              class="space-hint muted"
              *ngIf="
                !f.spaceLoading && f.spaceChecked && f.availableSpace == null
              "
              title="La estación no tiene capacidad de tanque o lectura de inventario para este producto"
            >
              <i class="fa fa-info-circle" aria-hidden="true"></i> Sin datos de
              inventario
            </small>
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Producto</span>
            <!-- ngx-select con tag de color por producto (pedido 2026-07-31),
                 mismo trato que el campo Estación de esta fila; el chip es el
                 mobil-* de la lista de sugerencias. Sin buscador (3 opciones). -->
            <ngx-select
              class="op-ngx-select"
              [allowClear]="false"
              [noAutoComplete]="true"
              [items]="orderProductOptions"
              optionValueField="value"
              optionTextField="label"
              placeholder="Selecciona…"
              appendTo="body"
              [dropDownMenuOtherClasses]="'op-appended-dropdown'"
              [(ngModel)]="f.product"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="updateRowSpace(f)"
            >
              <ng-template ngx-select-option let-option>
                <span
                  class="pipes-suggest__product"
                  [ngClass]="'mobil-' + option.value"
                  >{{ option.text }}</span
                >
              </ng-template>
              <ng-template ngx-select-option-selected let-option>
                <span
                  class="pipes-suggest__product"
                  [ngClass]="'mobil-' + option.value"
                  >{{ option.text }}</span
                >
              </ng-template>
            </ngx-select>
          </div>
          <!-- Material ya no se captura (junta MOBICO 16-oct): concepto interno de MOBICO. -->
          <div class="pipes-req__pipa__remove">
            <!-- Patrón estándar de eliminar del portal (.icon.delete, mismo del cronograma).
                             Siempre visible: deshabilitado mientras solo haya una pipa. -->
            <i
              class="fa fa-trash-o icon delete"
              aria-hidden="true"
              [class.disabled]="inlineForms.length < 2"
              (click)="inlineForms.length > 1 && removeOrderRow(i)"
              [title]="
                inlineForms.length > 1
                  ? 'Eliminar pipa'
                  : 'La solicitud necesita al menos una pipa'
              "
            ></i>
          </div>
        </div>

        <button
          type="button"
          class="pipes-req__add-pipa"
          (click)="addOrderRow()"
        >
          <i class="fa fa-plus" aria-hidden="true"></i> Agregar pipa
        </button>
        </div>

        <div class="pipes-req__new-foot">
          <button
            type="button"
            class="pipes-req__submit"
            [disabled]="!orderFormValid || savingOrder"
            (click)="submitOrderForm()"
          >
            {{ savingOrder ? "Enviando…" : "Enviar pedido" }}
          </button>
        </div>
      </div>
</ng-template>

<!-- Modal "Inventario proyectado" desde Sugerencias (componente compartido con
     Análisis de Pedido). Vista de estación: sin selector de estación. -->
<app-inventory-projection *ngIf="projModal" [rows]="projRows" [stationId]="projStation" [product]="projProduct"
  [stationSelector]="!onlyStation" (closed)="closeProjection()"></app-inventory-projection>
